// import React, { useState, useEffect, useMemo } from 'react';
// import { Link } from 'react-router-dom';
// import axios from 'axios';
// import ReactPaginate from 'react-paginate';
// import {
//     FaFilter,
//     FaSearch,
//     FaSync,
//     FaFileInvoice,
//     FaDownload,
//     FaUpload,
//     FaFileExcel,
//     FaEye,
//     FaEdit,
//     FaTrash,
//     FaPlus
// } from 'react-icons/fa';
// import Swal from 'sweetalert2';
// import { Button, Form, Row, Col, Card, Table, Badge, Offcanvas } from 'react-bootstrap';
// import withPermission from '../../utils/withPermission';
// import PurchaseOrderForm from '../purchaseorder/PurchaseOrderForm';

// const PODetails = () => {
//     // State management
//     const [purchaseOrders, setPurchaseOrders] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [vendors, setVendors] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedPurchaseOrderId, setSelectedPurchaseOrderId] = useState(null);
//     const [selectedPurchaseOrderData, setSelectedPurchaseOrderData] = useState(null);

//     // Pagination state
//     const [pagination, setPagination] = useState({
//         currentPage: 1,
//         pageCount: 0,
//         total: 0
//     });

//     // Filter state
//     const [filters, setFilters] = useState({
//         dateRange: { from: '', to: '' },
//         vendorId: '',
//         searchQuery: ''
//     });

//     // Permission hooks
//     const WithEditPermission = withPermission(({ children }) => children, ['purchaseorder-edit']);
//     const WithDeletePermission = withPermission(({ children }) => children, ['purchaseorder-delete']);
//     const WithCreatePermission = withPermission(({ children }) => children, ['purchaseorder-create']);

//     // Filter handlers
//     const updateFilter = (key, value) => {
//         setFilters(prev => ({
//             ...prev,
//             [key]: value
//         }));
//     };

//     const resetFilters = () => {
//         setFilters({
//             dateRange: { from: '', to: '' },
//             vendorId: '',
//             searchQuery: ''
//         });
//         fetchPurchaseOrders(1);
//     };

//     // Data fetching functions
//     const fetchVendors = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/contacts?type=vendor`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             setVendors(response.data.Data || []);
//         } catch (error) {
//             console.error("Error fetching vendors:", error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Failed to fetch vendors',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });
//         }
//     };

//     const fetchPurchaseOrders = async (page = 1, applyFilters = true) => {
//         try {
//             setLoading(true);
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             // Build params
//             let params = { page };

//             if (applyFilters) {
//                 if (filters.dateRange.from) params.from_date = filters.dateRange.from;
//                 if (filters.dateRange.to) params.to_date = filters.dateRange.to;
//                 if (filters.vendorId) params.vendor_id = filters.vendorId;
//                 if (filters.searchQuery) params.search = filters.searchQuery;
//             }

//             const response = await axios.get(`${backendUrl}/api/purchase-order`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 params
//             });

//             const purchaseOrderData = response.data.data || response.data.purchaseorders?.data || {};
//             let orders = purchaseOrderData.data || purchaseOrderData || [];

//             setPurchaseOrders(orders);
//             setPagination({
//                 currentPage: purchaseOrderData.current_page || 1,
//                 pageCount: purchaseOrderData.last_page || 1,
//                 total: purchaseOrderData.total || orders.length
//             });

//         } catch (error) {
//             console.error("Error fetching purchase orders:", error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Failed to load purchase orders',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Apply filters handler
//     const applyFilters = () => {
//         fetchPurchaseOrders(1, true);
//     };

//     // Pagination handler
//     const handlePageClick = (data) => {
//         const selectedPage = data.selected + 1;
//         fetchPurchaseOrders(selectedPage, true);
//     };

//     // Format currency
//     const formatAmount = (amount) => {
//         if (amount === null || amount === undefined || amount === '') return '0.00';

//         const num = parseFloat(amount);
//         if (isNaN(num)) return '0.00';

//         return num.toLocaleString('en-US', {
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2
//         });
//     };

//     // Calculate VAT amount
//     const calculateVAT = (order) => {
//         // If VAT is explicitly provided, use it
//         if (order.total_vat) return parseFloat(order.total_vat);

//         // Otherwise calculate based on amount and VAT percentage
//         const amount = parseFloat(order.base_amount || order.total_amount || 0);
//         const vatPercentage = order.vat_percentage || 5; // Default 5% VAT
//         return (amount * vatPercentage) / 100;
//     };

//     // Calculate total with VAT
//     const calculateTotalWithVAT = (order) => {
//         const amount = parseFloat(order.base_amount || order.total_amount || 0);
//         const vatAmount = calculateVAT(order);
//         return amount + vatAmount;
//     };

//     // Status badge component
//     const StatusBadge = ({ status }) => {
//         const statusConfig = {
//             'vendor_PO_generated': { label: 'Generated', class: 'primary' },
//             'approved': { label: 'Approved', class: 'success' },
//             'pending': { label: 'Pending', class: 'warning' },
//             'rejected': { label: 'Rejected', class: 'danger' },
//             'completed': { label: 'Completed', class: 'info' },
//             'vendor_payment_released': { label: 'Paid', class: 'success' }
//         };

//         const config = statusConfig[status] || { label: status, class: 'secondary' };

//         return <span className={`badge bg-${config.class}`}>{config.label}</span>;
//     };

//     // Modal handlers
//     const handleShowModal = (poId = null) => {
//         if (poId) {
//             const purchaseorderToEdit = purchaseOrders.find(purchaseorder => purchaseorder.id === poId);
//             if (purchaseorderToEdit) {
//                 setSelectedPurchaseOrderData(purchaseorderToEdit);
//             }
//         } else {
//             setSelectedPurchaseOrderData(null);
//         }
//         setSelectedPurchaseOrderId(poId);
//         setShowModal(true);
//     };

//     const handleCloseModal = () => {
//         setShowModal(false);
//         setSelectedPurchaseOrderId(null);
//         setSelectedPurchaseOrderData(null);
//     };

//     const handleSuccess = () => {
//         handleCloseModal();
//         fetchPurchaseOrders(pagination.currentPage, true);
//         Swal.fire({
//             toast: true,
//             position: 'top-end',
//             icon: 'success',
//             title: selectedPurchaseOrderId ? 'Purchase order updated successfully!' : 'Purchase order created successfully!',
//             timer: 3000,
//             showConfirmButton: false,
//         });
//     };

//     // Delete purchase order
//     const deletePurchaseOrder = async (id) => {
//         const result = await Swal.fire({
//             title: "Are you sure?",
//             text: "You won't be able to revert this!",
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonColor: "#d33",
//             cancelButtonColor: "#3085d6",
//             confirmButtonText: "Yes, delete it!",
//             cancelButtonText: "Cancel"
//         });

//         if (!result.isConfirmed) return;

//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             await axios.delete(`${backendUrl}/api/purchase-order/${id}`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             // Refresh the list
//             fetchPurchaseOrders(pagination.currentPage, true);

//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'success',
//                 title: 'Purchase order deleted successfully!',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });
//         } catch (error) {
//             console.error('Error deleting purchase order:', error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Failed to delete purchase order',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });
//         }
//     };

//     // Export functionality
//     const handleExport = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             // Build export parameters based on current filters
//             const exportParams = new URLSearchParams();

//             if (filters.dateRange.from) exportParams.append('from_date', filters.dateRange.from);
//             if (filters.dateRange.to) exportParams.append('to_date', filters.dateRange.to);
//             if (filters.vendorId) exportParams.append('vendor_id', filters.vendorId);
//             if (filters.searchQuery) exportParams.append('search', filters.searchQuery);

//             const response = await axios.get(`${backendUrl}/api/purchase-order/export?${exportParams.toString()}`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 responseType: 'blob'
//             });

//             // Create download link
//             const url = window.URL.createObjectURL(new Blob([response.data]));
//             const link = document.createElement('a');
//             link.href = url;

//             // Get filename from response headers or use default
//             const contentDisposition = response.headers['content-disposition'];
//             let filename = `purchase_orders_export_${new Date().toISOString().split('T')[0]}.xlsx`;

//             if (contentDisposition) {
//                 const filenameMatch = contentDisposition.match(/filename="(.+)"/);
//                 if (filenameMatch) {
//                     filename = filenameMatch[1];
//                 }
//             }

//             link.setAttribute('download', filename);
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//             window.URL.revokeObjectURL(url);

//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'success',
//                 title: 'Purchase orders exported successfully!',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });

//         } catch (error) {
//             console.error('Export error:', error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Failed to export purchase orders',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });
//         }
//     };

//     // Import functionality
//     const handleImport = async (event) => {
//         const file = event.target.files[0];
//         if (!file) return;

//         // Validate file type
//         const validTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'];
//         if (!validTypes.includes(file.type)) {
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Please select a valid Excel or CSV file',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });
//             return;
//         }

//         const result = await Swal.fire({
//             title: 'Import Purchase Orders',
//             text: 'Are you sure you want to import purchase orders from this file?',
//             icon: 'question',
//             showCancelButton: true,
//             confirmButtonColor: '#3085d6',
//             cancelButtonColor: '#d33',
//             confirmButtonText: 'Yes, import!',
//             cancelButtonText: 'Cancel'
//         });

//         if (!result.isConfirmed) {
//             event.target.value = '';
//             return;
//         }

//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const formData = new FormData();
//             formData.append('file', file);

//             const response = await axios.post(`${backendUrl}/api/purchase-order/import`, formData, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                     'Content-Type': 'multipart/form-data',
//                 },
//             });

//             const result = response.data;

//             let message = `Import completed successfully!<br>
//                           Imported: ${result.imported_count || result.count || 0}`;

//             if (result.errors && result.errors.length > 0) {
//                 message += `<br><br>Errors:<br>${result.errors.join('<br>')}`;
//             }

//             Swal.fire({
//                 title: 'Import Result',
//                 html: message,
//                 icon: 'success',
//                 confirmButtonText: 'OK'
//             });

//             // Refresh the list
//             fetchPurchaseOrders(1, true);

//         } catch (error) {
//             console.error('Import error:', error);
//             let errorMessage = 'Failed to import purchase orders';

//             if (error.response?.data?.message) {
//                 errorMessage = error.response.data.message;
//             } else if (error.message) {
//                 errorMessage = error.message;
//             }

//             Swal.fire({
//                 title: 'Import Failed',
//                 text: errorMessage,
//                 icon: 'error',
//                 confirmButtonText: 'OK'
//             });
//         } finally {
//             event.target.value = '';
//         }
//     };

//     // Initial data loading
//     useEffect(() => {
//         fetchVendors();
//         fetchPurchaseOrders(1, false);
//     }, []);

//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     {/* Header */}
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                                 <h4 className="mb-sm-0 font-size-18">Purchase Orders</h4>
//                                 <div className="page-title-right">
//                                     <WithCreatePermission>
//                                         <button
//                                             className="btn btn-primary"
//                                             onClick={() => handleShowModal()}
//                                         >
//                                             <FaPlus className="me-1" />
//                                             Add Purchase Order
//                                         </button>
//                                     </WithCreatePermission>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Filter Panel */}
//                     <div className="card filter-card mb-4">
//                         <div className="card-body">
//                             <h5 className="card-title mb-3">
//                                 <FaFilter className="me-2" />
//                                 Filter Purchase Orders
//                             </h5>

//                             <div className="row g-3">
//                                 {/* Date Filters */}
//                                 <div className="col-md-3">
//                                     <label className="form-label">From Date</label>
//                                     <input
//                                         type="date"
//                                         className="form-control"
//                                         value={filters.dateRange.from}
//                                         onChange={(e) => updateFilter('dateRange', { ...filters.dateRange, from: e.target.value })}
//                                     />
//                                 </div>

//                                 <div className="col-md-3">
//                                     <label className="form-label">To Date</label>
//                                     <input
//                                         type="date"
//                                         className="form-control"
//                                         value={filters.dateRange.to}
//                                         onChange={(e) => updateFilter('dateRange', { ...filters.dateRange, to: e.target.value })}
//                                     />
//                                 </div>

//                                 {/* Vendor Filter */}
//                                 <div className="col-md-3">
//                                     <label className="form-label">Vendor</label>
//                                     <select
//                                         className="form-select"
//                                         value={filters.vendorId}
//                                         onChange={(e) => updateFilter('vendorId', e.target.value)}
//                                     >
//                                         <option value="">All Vendors</option>
//                                         {vendors.map(vendor => (
//                                             <option key={vendor.id} value={vendor.id}>
//                                                 {vendor.name || vendor.business_name || `Vendor ${vendor.id}`}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 {/* Search */}
//                                 <div className="col-md-3">
//                                     <label className="form-label">Search</label>
//                                     <div className="input-group">
//                                         <span className="input-group-text">
//                                             <FaSearch />
//                                         </span>
//                                         <input
//                                             type="text"
//                                             className="form-control"
//                                             placeholder="Search by reference no..."
//                                             value={filters.searchQuery}
//                                             onChange={(e) => updateFilter('searchQuery', e.target.value)}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Action Buttons */}
//                             <div className="row g-3 mt-2">
//                                 <div className="col-md-12 d-flex align-items-end justify-content-between">
//                                     <div>
//                                         <button
//                                             className="btn btn-primary me-2"
//                                             onClick={applyFilters}
//                                         >
//                                             Apply Filters
//                                         </button>
//                                         <button
//                                             className="btn btn-outline-secondary me-2"
//                                             onClick={resetFilters}
//                                         >
//                                             Clear All
//                                         </button>
//                                     </div>
//                                     <div className="d-flex align-items-center gap-2">
//                                         <button
//                                             type="button"
//                                             className="btn btn-light border"
//                                             onClick={handleExport}
//                                             data-bs-toggle="tooltip"
//                                             data-bs-placement="top"
//                                             title="Export to Excel"
//                                         >
//                                             <FaFileExcel className="text-success" />
//                                         </button>

//                                         <input
//                                             type="file"
//                                             accept=".xlsx, .xls, .csv"
//                                             id="importFile"
//                                             onChange={handleImport}
//                                             style={{ display: "none" }}
//                                         />
//                                         <label
//                                             htmlFor="importFile"
//                                             className="btn btn-light border mb-0"
//                                             data-bs-toggle="tooltip"
//                                             data-bs-placement="top"
//                                             title="Import from Excel"
//                                         >
//                                             <FaUpload className="text-primary" />
//                                         </label>

//                                         <button
//                                             className="btn btn-outline-primary"
//                                             onClick={() => fetchPurchaseOrders(1, true)}
//                                         >
//                                             <FaSync className="me-1" /> Refresh
//                                         </button>

//                                         <div className="text-muted ms-3">
//                                             <small>
//                                                 Showing {purchaseOrders.length} of {pagination.total} records
//                                             </small>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Purchase Orders Table */}
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="card">
//                                 <div className="card-body">
//                                     <div className="d-flex justify-content-between align-items-center mb-3">
//                                         <h5 className="card-title mb-0">Purchase Orders</h5>
//                                     </div>


//                                     <div className="table-responsive">
//                                         <table className="table align-middle table-nowrap table-hover">
//                                             <thead className="table-sales-gradient">
//                                                 <tr>
//                                                     <th>#</th>
//                                                     <th>Date</th>
//                                                     <th>Reference No</th>
//                                                     <th>Vendor Name</th>
//                                                     <th>Amount</th>
//                                                     <th>VAT</th>
//                                                     <th>VAT Amount</th>
//                                                     <th>Total with VAT</th>
//                                                     <th>Status</th>
//                                                     <th>Actions</th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 {purchaseOrders.length > 0 ? (
//                                                     purchaseOrders.map((order, index) => {
//                                                         const vatAmount = calculateVAT(order);
//                                                         const totalWithVAT = calculateTotalWithVAT(order);
//                                                         const vendorCurrency = order.vendor?.currency || 'AED';
//                                                         const isUSD = vendorCurrency === 'USD';

//                                                         return (
//                                                             <tr key={order.id}>
//                                                                 <td>{index + 1}</td>
//                                                                 <td>
//                                                                     {new Date(order.date).toLocaleDateString()}
//                                                                 </td>
//                                                                 <td>
//                                                                     <strong>{order.ref_no}</strong>
//                                                                 </td>
//                                                                 <td>
//                                                                     {order.vendor?.name || ''}

//                                                                 </td>
//                                                                 <td>
//                                                                     <strong>{formatAmount(order.base_amount || order.amount)}</strong>
//                                                                 </td>
//                                                                 <td>
//                                                                     {isUSD ? (
//                                                                         <Badge bg="light">No VAT</Badge>
//                                                                     ) : (
//                                                                         `${order.vat_percentage || 5}%`
//                                                                     )}
//                                                                 </td>
//                                                                 <td>
//                                                                     {isUSD ? (
//                                                                         <Badge bg="secondary"></Badge>
//                                                                     ) : (
//                                                                         formatAmount(vatAmount)
//                                                                     )}
//                                                                 </td>
//                                                                 <td>
//                                                                     <strong>
//                                                                         {isUSD ? (
//                                                                             formatAmount(order.amount || order.total_amount)
//                                                                         ) : (
//                                                                             formatAmount(totalWithVAT)
//                                                                         )}
//                                                                     </strong>
//                                                                 </td>
//                                                                 <td>
//                                                                     <StatusBadge status={order.po_status} />
//                                                                 </td>
//                                                                 <td>
//                                                                     <div className="dropdown">
//                                                                         <i
//                                                                             className="mdi mdi-dots-horizontal font-size-18"
//                                                                             data-bs-toggle="dropdown"
//                                                                             aria-expanded="false"
//                                                                             style={{ cursor: "pointer" }}
//                                                                         ></i>
//                                                                         <ul className="dropdown-menu">
//                                                                             <li>
//                                                                                 <button
//                                                                                     className="dropdown-item"
//                                                                                     onClick={() => handleShowModal(order.id)}
//                                                                                 >
//                                                                                     <FaEye className="me-2" />
//                                                                                     View Details
//                                                                                 </button>
//                                                                             </li>
//                                                                             <WithEditPermission>
//                                                                                 <li>
//                                                                                     <button
//                                                                                         className="dropdown-item"
//                                                                                         onClick={() => handleShowModal(order.id)}
//                                                                                     >
//                                                                                         <FaEdit className="me-2" />
//                                                                                         Edit
//                                                                                     </button>
//                                                                                 </li>
//                                                                             </WithEditPermission>
//                                                                             <WithDeletePermission>
//                                                                                 <li>
//                                                                                     <button
//                                                                                         className="dropdown-item text-danger"
//                                                                                         onClick={() => deletePurchaseOrder(order.id)}
//                                                                                     >
//                                                                                         <FaTrash className="me-2" />
//                                                                                         Delete
//                                                                                     </button>
//                                                                                 </li>
//                                                                             </WithDeletePermission>
//                                                                         </ul>
//                                                                     </div>
//                                                                 </td>
//                                                             </tr>
//                                                         );
//                                                     })
//                                                 ) : (
//                                                     <tr>
//                                                         <td colSpan="10" className="text-center py-4">
//                                                             <div className="text-muted">
//                                                                 <FaFileInvoice size={48} className="mb-2" />
//                                                                 <p>No purchase orders found</p>

//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 )}
//                                             </tbody>
//                                         </table>
//                                     </div>


//                                     {/* Pagination */}
//                                     {pagination.pageCount > 1 && (
//                                         <div className="d-flex justify-content-end mt-3">
//                                             <ReactPaginate
//                                                 previousLabel={'<'}
//                                                 nextLabel={'>'}
//                                                 breakLabel={'...'}
//                                                 pageCount={pagination.pageCount}
//                                                 marginPagesDisplayed={2}
//                                                 pageRangeDisplayed={3}
//                                                 onPageChange={handlePageClick}
//                                                 containerClassName={'pagination pagination-rounded mb-0'}
//                                                 pageClassName={'page-item'}
//                                                 pageLinkClassName={'page-link'}
//                                                 previousClassName={'page-item'}
//                                                 previousLinkClassName={'page-link'}
//                                                 nextClassName={'page-item'}
//                                                 nextLinkClassName={'page-link'}
//                                                 breakClassName={'page-item'}
//                                                 breakLinkClassName={'page-link'}
//                                                 activeClassName={'active'}
//                                             />
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Purchase Order Modal */}
//             <PurchaseOrderForm
//                 showModal={showModal}
//                 handleClose={handleCloseModal}
//                 poId={selectedPurchaseOrderId}
//                 purchaseorderData={selectedPurchaseOrderData}
//                 onSuccess={handleSuccess}
//                 vendors={vendors}
//             />
//         </div>
//     );
// };

// export default PODetails;


// import React, { useState, useEffect, useMemo } from 'react';
// import { Link } from 'react-router-dom';
// import axios from 'axios';
// import ReactPaginate from 'react-paginate';
// import {
//     FaFilter,
//     FaSearch,
//     FaSync,
//     FaFileInvoice,
//     FaDownload,
//     FaUpload,
//     FaFileExcel,
//     FaEye,
//     FaEdit,
//     FaTrash,
//     FaPlus
// } from 'react-icons/fa';
// import Swal from 'sweetalert2';
// import { Button, Form, Row, Col, Card, Table, Badge, Offcanvas } from 'react-bootstrap';
// import withPermission from '../../utils/withPermission';
// import PurchaseOrderForm from '../purchaseorder/PurchaseOrderForm';

// const PODetails = () => {
//     // State management
//     const [purchaseOrders, setPurchaseOrders] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [vendors, setVendors] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedPurchaseOrderId, setSelectedPurchaseOrderId] = useState(null);
//     const [selectedPurchaseOrderData, setSelectedPurchaseOrderData] = useState(null);

//     // Pagination state
//     const [pagination, setPagination] = useState({
//         currentPage: 1,
//         pageCount: 0,
//         total: 0
//     });

//     // Filter state
//     const [filters, setFilters] = useState({
//         dateRange: { from: '', to: '' },
//         vendorId: '',
//         searchQuery: ''
//     });

//     // Permission hooks
//     const WithEditPermission = withPermission(({ children }) => children, ['purchaseorder-edit']);
//     const WithDeletePermission = withPermission(({ children }) => children, ['purchaseorder-delete']);
//     const WithCreatePermission = withPermission(({ children }) => children, ['purchaseorder-create']);

//     // Filter handlers
//     const updateFilter = (key, value) => {
//         setFilters(prev => ({
//             ...prev,
//             [key]: value
//         }));
//     };

//     const resetFilters = () => {
//         setFilters({
//             dateRange: { from: '', to: '' },
//             vendorId: '',
//             searchQuery: ''
//         });
//         fetchPurchaseOrders(1);
//     };

//     // Data fetching functions
//     const fetchVendors = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/contacts?type=vendor`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             setVendors(response.data.Data || []);
//         } catch (error) {
//             console.error("Error fetching vendors:", error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Failed to fetch vendors',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });
//         }
//     };

//     const fetchPurchaseOrders = async (page = 1, applyFilters = true) => {
//         try {
//             setLoading(true);
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             // Build params
//             let params = { page };

//             if (applyFilters) {
//                 if (filters.dateRange.from) params.from_date = filters.dateRange.from;
//                 if (filters.dateRange.to) params.to_date = filters.dateRange.to;
//                 if (filters.vendorId) params.vendor_id = filters.vendorId;
//                 if (filters.searchQuery) params.search = filters.searchQuery;
//             }

//             const response = await axios.get(`${backendUrl}/api/purchase-order`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 params
//             });

//             const purchaseOrderData = response.data.data || response.data.purchaseorders?.data || {};
//             let orders = purchaseOrderData.data || purchaseOrderData || [];

//             setPurchaseOrders(orders);
//             setPagination({
//                 currentPage: purchaseOrderData.current_page || 1,
//                 pageCount: purchaseOrderData.last_page || 1,
//                 total: purchaseOrderData.total || orders.length
//             });

//         } catch (error) {
//             console.error("Error fetching purchase orders:", error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Failed to load purchase orders',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Apply filters handler
//     const applyFilters = () => {
//         fetchPurchaseOrders(1, true);
//     };

//     // Pagination handler
//     const handlePageClick = (data) => {
//         const selectedPage = data.selected + 1;
//         fetchPurchaseOrders(selectedPage, true);
//     };

//     // Format currency
//     const formatAmount = (amount) => {
//         if (amount === null || amount === undefined || amount === '') return '0.00';

//         const num = parseFloat(amount);
//         if (isNaN(num)) return '0.00';

//         return num.toLocaleString('en-US', {
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2
//         });
//     };

//    // Helper to get product details consistently
// const getProductDetails = (order) => {
//     return order.productItemDetails || order.product_item_details || [];
// };

// // Check if PO was created from expense
// const isPOFromExpense = (order) => {
//     const productDetails = getProductDetails(order);

//     if (productDetails.length > 0) {
//         const firstItem = productDetails[0];

//         // Get productable_type from snake_case or camelCase
//         const productableType = firstItem.productable_type || firstItem.productableType;

//         // Check if this is an expense PO
//         if (productableType === 'App\\Models\\ProjectExpense') {
//             return true;
//         }

//         // Additional check: Look for patterns in item name/description
//         const itemName = firstItem.item_name || firstItem.itemName || '';
//         if (itemName.includes('Expense Payment')) {
//             return true;
//         }
//     }

//     return false;
// };

// // Get expense details from PO (if created from expense)
// const getExpenseDetailsFromPO = (order) => {
//     const productDetails = getProductDetails(order);

//     if (productDetails.length === 0) {
//         return null;
//     }

//     // Look for expense-linked product item
//     const expenseItem = productDetails.find(item => {
//         const productableType = item.productable_type || item.productableType;
//         return productableType === 'App\\Models\\ProjectExpense';
//     });

//     // If no expense item found but product details exist, check first item
//     return expenseItem || productDetails[0];
// };

//     // Calculate VAT amount based on expense tax_type
//     const calculateVAT = (order) => {
//         // If PO was created from expense, check the expense tax_type
//         const expenseItem = getExpenseDetailsFromPO(order);

//         if (expenseItem) {
//             // This PO was created from an expense
//             // Check if we have expense data in the item
//             if (expenseItem.productable) {
//                 // If expense data is loaded
//                 const expense = expenseItem.productable;
//                 if (expense.tax_type === 'taxable') {
//                     // For taxable expenses, show tax amount from item
//                     return parseFloat(expenseItem.tax || 0);
//                 } else {
//                     // For non-taxable expenses, no VAT
//                     return 0;
//                 }
//             } else {
//                 // If expense data not loaded, check item name/description
//                 if (expenseItem.item_description && expenseItem.item_description.includes('taxable')) {
//                     return parseFloat(expenseItem.tax || 0);
//                 }
//                 // Default to no VAT for expense POs
//                 return 0;
//             }
//         }

//         // For regular POs (not from expenses)
//         // If VAT is explicitly provided, use it
//         if (order.total_vat) return parseFloat(order.total_vat);

//         // Otherwise calculate based on amount and VAT percentage
//         const amount = parseFloat(order.base_amount || order.total_amount || 0);
//         const vatPercentage = order.vat_percentage || 5; // Default 5% VAT
//         return (amount * vatPercentage) / 100;
//     };

//     // Calculate VAT percentage
//     const calculateVATPercentage = (order) => {
//         const expenseItem = getExpenseDetailsFromPO(order);

//         if (expenseItem && expenseItem.productable) {
//             const expense = expenseItem.productable;
//             if (expense.tax_type === 'taxable') {
//                 return expense.tax || 5; // Return tax percentage
//             }
//             return 0; // Non-taxable
//         }

//         // For regular POs
//         return order.vat_percentage || 5;
//     };

//     // Calculate total with VAT
//     const calculateTotalWithVAT = (order) => {
//         const amount = parseFloat(order.base_amount || order.total_amount || 0);
//         const vatAmount = calculateVAT(order);
//         return amount + vatAmount;
//     };

//     // Determine if VAT should be shown
//     const shouldShowVAT = (order) => {
//         const expenseItem = getExpenseDetailsFromPO(order);

//         if (expenseItem) {
//             // For expense-based POs, show VAT only if expense is taxable
//             if (expenseItem.productable) {
//                 return expenseItem.productable.tax_type === 'taxable';
//             }
//             // Check item description as fallback
//             if (expenseItem.item_description) {
//                 return expenseItem.item_description.toLowerCase().includes('taxable');
//             }
//             return false; // Default: don't show VAT for expense POs
//         }

//         // For regular POs, show VAT
//         return true;
//     };

//     // Get display amount (base amount)
//     const getDisplayAmount = (order) => {
//         const expenseItem = getExpenseDetailsFromPO(order);

//         if (expenseItem && expenseItem.productable) {
//             const expense = expenseItem.productable;
//             if (expense.tax_type === 'taxable') {
//                 return expense.amount_without_tax || expense.amount || 0;
//             } else {
//                 return expense.amount || expense.total_amount || 0;
//             }
//         }

//         return order.base_amount || order.amount || 0;
//     };

//     // Status badge component
//     const StatusBadge = ({ status }) => {
//         const statusConfig = {
//             'vendor_PO_generated': { label: 'Generated', class: 'primary' },
//             'approved': { label: 'Approved', class: 'success' },
//             'pending': { label: 'Pending', class: 'warning' },
//             'rejected': { label: 'Rejected', class: 'danger' },
//             'completed': { label: 'Completed', class: 'info' },
//             'vendor_payment_released': { label: 'Paid', class: 'success' }
//         };

//         const config = statusConfig[status] || { label: status, class: 'secondary' };

//         return <span className={`badge bg-${config.class}`}>{config.label}</span>;
//     };

//     // Get expense type badge
//     const ExpenseTypeBadge = ({ order }) => {
//         const expenseItem = getExpenseDetailsFromPO(order);

//         if (!expenseItem) {
//             return null; // Not an expense PO
//         }

//         let expenseType = 'Unknown';
//         let badgeClass = 'secondary';

//         if (expenseItem.productable) {
//             const expense = expenseItem.productable;
//             if (expense.tax_type === 'taxable') {
//                 expenseType = 'Taxable';
//                 badgeClass = 'success';
//             } else {
//                 expenseType = 'Non-Taxable';
//                 badgeClass = 'warning';
//             }
//         } else if (expenseItem.item_description) {
//             if (expenseItem.item_description.toLowerCase().includes('taxable')) {
//                 expenseType = 'Taxable';
//                 badgeClass = 'success';
//             } else {
//                 expenseType = 'Non-Taxable';
//                 badgeClass = 'warning';
//             }
//         }

//         return <Badge bg={badgeClass} className="ms-1">{expenseType}</Badge>;
//     };

//     // Modal handlers
//     const handleShowModal = (poId = null) => {
//         if (poId) {
//             const purchaseorderToEdit = purchaseOrders.find(purchaseorder => purchaseorder.id === poId);
//             if (purchaseorderToEdit) {
//                 setSelectedPurchaseOrderData(purchaseorderToEdit);
//             }
//         } else {
//             setSelectedPurchaseOrderData(null);
//         }
//         setSelectedPurchaseOrderId(poId);
//         setShowModal(true);
//     };

//     const handleCloseModal = () => {
//         setShowModal(false);
//         setSelectedPurchaseOrderId(null);
//         setSelectedPurchaseOrderData(null);
//     };

//     const handleSuccess = () => {
//         handleCloseModal();
//         fetchPurchaseOrders(pagination.currentPage, true);
//         Swal.fire({
//             toast: true,
//             position: 'top-end',
//             icon: 'success',
//             title: selectedPurchaseOrderId ? 'Purchase order updated successfully!' : 'Purchase order created successfully!',
//             timer: 3000,
//             showConfirmButton: false,
//         });
//     };

//     // Delete purchase order
//     const deletePurchaseOrder = async (id) => {
//         const result = await Swal.fire({
//             title: "Are you sure?",
//             text: "You won't be able to revert this!",
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonColor: "#d33",
//             cancelButtonColor: "#3085d6",
//             confirmButtonText: "Yes, delete it!",
//             cancelButtonText: "Cancel"
//         });

//         if (!result.isConfirmed) return;

//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             await axios.delete(`${backendUrl}/api/purchase-order/${id}`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             // Refresh the list
//             fetchPurchaseOrders(pagination.currentPage, true);

//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'success',
//                 title: 'Purchase order deleted successfully!',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });
//         } catch (error) {
//             console.error('Error deleting purchase order:', error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Failed to delete purchase order',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });
//         }
//     };

//     // Export functionality
//     const handleExport = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             // Build export parameters based on current filters
//             const exportParams = new URLSearchParams();

//             if (filters.dateRange.from) exportParams.append('from_date', filters.dateRange.from);
//             if (filters.dateRange.to) exportParams.append('to_date', filters.dateRange.to);
//             if (filters.vendorId) exportParams.append('vendor_id', filters.vendorId);
//             if (filters.searchQuery) exportParams.append('search', filters.searchQuery);

//             const response = await axios.get(`${backendUrl}/api/purchase-order/export?${exportParams.toString()}`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 responseType: 'blob'
//             });

//             // Create download link
//             const url = window.URL.createObjectURL(new Blob([response.data]));
//             const link = document.createElement('a');
//             link.href = url;

//             // Get filename from response headers or use default
//             const contentDisposition = response.headers['content-disposition'];
//             let filename = `purchase_orders_export_${new Date().toISOString().split('T')[0]}.xlsx`;

//             if (contentDisposition) {
//                 const filenameMatch = contentDisposition.match(/filename="(.+)"/);
//                 if (filenameMatch) {
//                     filename = filenameMatch[1];
//                 }
//             }

//             link.setAttribute('download', filename);
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//             window.URL.revokeObjectURL(url);

//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'success',
//                 title: 'Purchase orders exported successfully!',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });

//         } catch (error) {
//             console.error('Export error:', error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Failed to export purchase orders',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });
//         }
//     };

//     // Import functionality
//     const handleImport = async (event) => {
//         const file = event.target.files[0];
//         if (!file) return;

//         // Validate file type
//         const validTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'];
//         if (!validTypes.includes(file.type)) {
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Please select a valid Excel or CSV file',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });
//             return;
//         }

//         const result = await Swal.fire({
//             title: 'Import Purchase Orders',
//             text: 'Are you sure you want to import purchase orders from this file?',
//             icon: 'question',
//             showCancelButton: true,
//             confirmButtonColor: '#3085d6',
//             cancelButtonColor: '#d33',
//             confirmButtonText: 'Yes, import!',
//             cancelButtonText: 'Cancel'
//         });

//         if (!result.isConfirmed) {
//             event.target.value = '';
//             return;
//         }

//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const formData = new FormData();
//             formData.append('file', file);

//             const response = await axios.post(`${backendUrl}/api/purchase-order/import`, formData, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                     'Content-Type': 'multipart/form-data',
//                 },
//             });

//             const result = response.data;

//             let message = `Import completed successfully!<br>
//                           Imported: ${result.imported_count || result.count || 0}`;

//             if (result.errors && result.errors.length > 0) {
//                 message += `<br><br>Errors:<br>${result.errors.join('<br>')}`;
//             }

//             Swal.fire({
//                 title: 'Import Result',
//                 html: message,
//                 icon: 'success',
//                 confirmButtonText: 'OK'
//             });

//             // Refresh the list
//             fetchPurchaseOrders(1, true);

//         } catch (error) {
//             console.error('Import error:', error);
//             let errorMessage = 'Failed to import purchase orders';

//             if (error.response?.data?.message) {
//                 errorMessage = error.response.data.message;
//             } else if (error.message) {
//                 errorMessage = error.message;
//             }

//             Swal.fire({
//                 title: 'Import Failed',
//                 text: errorMessage,
//                 icon: 'error',
//                 confirmButtonText: 'OK'
//             });
//         } finally {
//             event.target.value = '';
//         }
//     };

//     // Initial data loading
//     useEffect(() => {
//         fetchVendors();
//         fetchPurchaseOrders(1, false);
//     }, []);

//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     {/* Header */}
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                                 <h4 className="mb-sm-0 font-size-18">Purchase Orders</h4>
//                                 <div className="page-title-right">
//                                     <WithCreatePermission>
//                                         <button
//                                             className="btn btn-primary"
//                                             onClick={() => handleShowModal()}
//                                         >
//                                             <FaPlus className="me-1" />
//                                             Add Purchase Order
//                                         </button>
//                                     </WithCreatePermission>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Filter Panel */}
//                     <div className="card filter-card mb-4">
//                         <div className="card-body">
//                             <h5 className="card-title mb-3">
//                                 <FaFilter className="me-2" />
//                                 Filter Purchase Orders
//                             </h5>

//                             <div className="row g-3">
//                                 {/* Date Filters */}
//                                 <div className="col-md-3">
//                                     <label className="form-label">From Date</label>
//                                     <input
//                                         type="date"
//                                         className="form-control"
//                                         value={filters.dateRange.from}
//                                         onChange={(e) => updateFilter('dateRange', { ...filters.dateRange, from: e.target.value })}
//                                     />
//                                 </div>

//                                 <div className="col-md-3">
//                                     <label className="form-label">To Date</label>
//                                     <input
//                                         type="date"
//                                         className="form-control"
//                                         value={filters.dateRange.to}
//                                         onChange={(e) => updateFilter('dateRange', { ...filters.dateRange, to: e.target.value })}
//                                     />
//                                 </div>

//                                 {/* Vendor Filter */}
//                                 <div className="col-md-3">
//                                     <label className="form-label">Vendor</label>
//                                     <select
//                                         className="form-select"
//                                         value={filters.vendorId}
//                                         onChange={(e) => updateFilter('vendorId', e.target.value)}
//                                     >
//                                         <option value="">All Vendors</option>
//                                         {vendors.map(vendor => (
//                                             <option key={vendor.id} value={vendor.id}>
//                                                 {vendor.name || vendor.business_name || `Vendor ${vendor.id}`}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 {/* Search */}
//                                 <div className="col-md-3">
//                                     <label className="form-label">Search</label>
//                                     <div className="input-group">
//                                         <span className="input-group-text">
//                                             <FaSearch />
//                                         </span>
//                                         <input
//                                             type="text"
//                                             className="form-control"
//                                             placeholder="Search by reference no..."
//                                             value={filters.searchQuery}
//                                             onChange={(e) => updateFilter('searchQuery', e.target.value)}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Action Buttons */}
//                             <div className="row g-3 mt-2">
//                                 <div className="col-md-12 d-flex align-items-end justify-content-between">
//                                     <div>
//                                         <button
//                                             className="btn btn-primary me-2"
//                                             onClick={applyFilters}
//                                         >
//                                             Apply Filters
//                                         </button>
//                                         <button
//                                             className="btn btn-outline-secondary me-2"
//                                             onClick={resetFilters}
//                                         >
//                                             Clear All
//                                         </button>
//                                     </div>
//                                     <div className="d-flex align-items-center gap-2">
//                                         <button
//                                             type="button"
//                                             className="btn btn-light border"
//                                             onClick={handleExport}
//                                             data-bs-toggle="tooltip"
//                                             data-bs-placement="top"
//                                             title="Export to Excel"
//                                         >
//                                             <FaFileExcel className="text-success" />
//                                         </button>

//                                         <input
//                                             type="file"
//                                             accept=".xlsx, .xls, .csv"
//                                             id="importFile"
//                                             onChange={handleImport}
//                                             style={{ display: "none" }}
//                                         />
//                                         <label
//                                             htmlFor="importFile"
//                                             className="btn btn-light border mb-0"
//                                             data-bs-toggle="tooltip"
//                                             data-bs-placement="top"
//                                             title="Import from Excel"
//                                         >
//                                             <FaUpload className="text-primary" />
//                                         </label>

//                                         <button
//                                             className="btn btn-outline-primary"
//                                             onClick={() => fetchPurchaseOrders(1, true)}
//                                         >
//                                             <FaSync className="me-1" /> Refresh
//                                         </button>

//                                         <div className="text-muted ms-3">
//                                             <small>
//                                                 Showing {purchaseOrders.length} of {pagination.total} records
//                                             </small>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Purchase Orders Table */}
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="card">
//                                 <div className="card-body">
//                                     <div className="d-flex justify-content-between align-items-center mb-3">
//                                         <h5 className="card-title mb-0">Purchase Orders</h5>
//                                     </div>

//                                     <div className="table-responsive">
//                                         <table className="table align-middle table-nowrap table-hover">
//                                             <thead className="table-sales-gradient">
//                                                 <tr>
//                                                     <th>#</th>
//                                                     <th>Date</th>
//                                                     <th>Reference No</th>
//                                                     <th>Vendor Name</th>
//                                                     <th>Amount</th>
//                                                     <th>VAT</th>
//                                                     <th>VAT Amount</th>
//                                                     <th>Total with VAT</th>
//                                                     <th>Status</th>
//                                                     <th>Actions</th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 {purchaseOrders.length > 0 ? (
//                                                     purchaseOrders.map((order, index) => {
//                                                         const isExpensePO = isPOFromExpense(order);
//                                                         const showVAT = shouldShowVAT(order);
//                                                         const vatPercentage = calculateVATPercentage(order);
//                                                         const vatAmount = calculateVAT(order);
//                                                         const displayAmount = getDisplayAmount(order);
//                                                         const totalWithVAT = calculateTotalWithVAT(order);

//                                                         return (
//                                                             <tr key={order.id}>
//                                                                 <td>{index + 1}</td>
//                                                                 <td>
//                                                                     {new Date(order.date).toLocaleDateString()}
//                                                                 </td>
//                                                                 <td>
//                                                                     <strong>{order.ref_no}</strong>

//                                                                 </td>
//                                                                 <td>
//                                                                     {order.vendor?.name || ''}
//                                                                 </td>

//                                                                 <td>
//                                                                     <strong>{formatAmount(displayAmount)}</strong>
//                                                                 </td>
//                                                                 <td>
//                                                                     {showVAT ? (
//                                                                         `${vatPercentage}%`
//                                                                     ) : null
//                                                                     }
//                                                                 </td>
//                                                                 <td>
//                                                                     {showVAT ? (
//                                                                         formatAmount(vatAmount)
//                                                                     ) : null}
//                                                                 </td>
//                                                                 <td>
//                                                                     <strong>
//                                                                         {showVAT ? (
//                                                                             formatAmount(totalWithVAT)
//                                                                         ) : (
//                                                                             formatAmount(displayAmount)
//                                                                         )}
//                                                                     </strong>
//                                                                 </td>
//                                                                 <td>
//                                                                     <StatusBadge status={order.po_status} />
//                                                                 </td>
//                                                                 <td>
//                                                                     <div className="dropdown">
//                                                                         <i
//                                                                             className="mdi mdi-dots-horizontal font-size-18"
//                                                                             data-bs-toggle="dropdown"
//                                                                             aria-expanded="false"
//                                                                             style={{ cursor: "pointer" }}
//                                                                         ></i>
//                                                                         <ul className="dropdown-menu">
//                                                                             <li>
//                                                                                 <button
//                                                                                     className="dropdown-item"
//                                                                                     onClick={() => handleShowModal(order.id)}
//                                                                                 >
//                                                                                     <FaEye className="me-2" />
//                                                                                     View Details
//                                                                                 </button>
//                                                                             </li>
//                                                                             <WithEditPermission>
//                                                                                 <li>
//                                                                                     <button
//                                                                                         className="dropdown-item"
//                                                                                         onClick={() => handleShowModal(order.id)}
//                                                                                     >
//                                                                                         <FaEdit className="me-2" />
//                                                                                         Edit
//                                                                                     </button>
//                                                                                 </li>
//                                                                             </WithEditPermission>
//                                                                             <WithDeletePermission>
//                                                                                 <li>
//                                                                                     <button
//                                                                                         className="dropdown-item text-danger"
//                                                                                         onClick={() => deletePurchaseOrder(order.id)}
//                                                                                     >
//                                                                                         <FaTrash className="me-2" />
//                                                                                         Delete
//                                                                                     </button>
//                                                                                 </li>
//                                                                             </WithDeletePermission>
//                                                                         </ul>
//                                                                     </div>
//                                                                 </td>
//                                                             </tr>
//                                                         );
//                                                     })
//                                                 ) : (
//                                                     <tr>
//                                                         <td colSpan="11" className="text-center py-4">
//                                                             <div className="text-muted">
//                                                                 <FaFileInvoice size={48} className="mb-2" />
//                                                                 <p>No purchase orders found</p>
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 )}
//                                             </tbody>
//                                         </table>
//                                     </div>

//                                     {/* Pagination */}
//                                     {pagination.pageCount > 1 && (
//                                         <div className="d-flex justify-content-end mt-3">
//                                             <ReactPaginate
//                                                 previousLabel={'<'}
//                                                 nextLabel={'>'}
//                                                 breakLabel={'...'}
//                                                 pageCount={pagination.pageCount}
//                                                 marginPagesDisplayed={2}
//                                                 pageRangeDisplayed={3}
//                                                 onPageChange={handlePageClick}
//                                                 containerClassName={'pagination pagination-rounded mb-0'}
//                                                 pageClassName={'page-item'}
//                                                 pageLinkClassName={'page-link'}
//                                                 previousClassName={'page-item'}
//                                                 previousLinkClassName={'page-link'}
//                                                 nextClassName={'page-item'}
//                                                 nextLinkClassName={'page-link'}
//                                                 breakClassName={'page-item'}
//                                                 breakLinkClassName={'page-link'}
//                                                 activeClassName={'active'}
//                                             />
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Purchase Order Modal */}
//             <PurchaseOrderForm
//                 showModal={showModal}
//                 handleClose={handleCloseModal}
//                 poId={selectedPurchaseOrderId}
//                 purchaseorderData={selectedPurchaseOrderData}
//                 onSuccess={handleSuccess}
//                 vendors={vendors}
//             />
//         </div>
//     );
// };

// export default PODetails;


// import React, { useState, useEffect, useMemo } from 'react';
// import { Link } from 'react-router-dom';
// import axios from 'axios';
// import ReactPaginate from 'react-paginate';
// import {
//     FaFilter,
//     FaSearch,
//     FaSync,
//     FaFileInvoice,
//     FaDownload,
//     FaUpload,
//     FaFileExcel,
//     FaEye,
//     FaEdit,
//     FaTrash,
//     FaPlus,
//     FaPaperclip,
//     FaFilePdf,
//     FaFileImage,
//     FaTimes
// } from 'react-icons/fa';
// import Swal from 'sweetalert2';
// import { Button, Form, Row, Col, Card, Table, Badge, Offcanvas, Modal, Spinner } from 'react-bootstrap';
// import withPermission from '../../utils/withPermission';
// import PurchaseOrderForm from '../purchaseorder/PurchaseOrderForm';

// const PODetails = () => {
//     // State management
//     const [purchaseOrders, setPurchaseOrders] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [vendors, setVendors] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedPurchaseOrderId, setSelectedPurchaseOrderId] = useState(null);
//     const [selectedPurchaseOrderData, setSelectedPurchaseOrderData] = useState(null);

//     // New states for upload and edit features
//     const [showUploadModal, setShowUploadModal] = useState(false);
//     const [showEditModal, setShowEditModal] = useState(false);
//     const [uploadFile, setUploadFile] = useState(null);
//     const [uploadLoading, setUploadLoading] = useState(false);
//     const [editFormData, setEditFormData] = useState({ ref_no: '', amount: '' });
//     const [editLoading, setEditLoading] = useState(false);
//     const [editErrors, setEditErrors] = useState({});
//     const [currentPage, setCurrentPage] = useState(1);
//     const [pageCount, setPageCount] = useState(1);

//     // Pagination state
//     const [pagination, setPagination] = useState({
//         currentPage: 1,
//         pageCount: 0,
//         total: 0
//     });

//     // Filter state
//     const [filters, setFilters] = useState({
//         dateRange: { from: '', to: '' },
//         vendorId: '',
//         searchQuery: ''
//     });

//     // Permission hooks
//     const WithEditPermission = withPermission(({ children }) => children, ['purchaseorder-edit']);
//     const WithDeletePermission = withPermission(({ children }) => children, ['purchaseorder-delete']);
//     const WithCreatePermission = withPermission(({ children }) => children, ['purchaseorder-create']);

//     // Filter handlers
//     const updateFilter = (key, value) => {
//         setFilters(prev => ({
//             ...prev,
//             [key]: value
//         }));
//     };

//     const resetFilters = () => {
//         setFilters({
//             dateRange: { from: '', to: '' },
//             vendorId: '',
//             searchQuery: ''
//         });
//         fetchPurchaseOrders(1);
//     };

//     // Data fetching functions
//     const fetchVendors = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/contacts?type=vendor`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             setVendors(response.data.Data || []);
//         } catch (error) {
//             console.error("Error fetching vendors:", error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Failed to fetch vendors',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });
//         }
//     };

//     const fetchPurchaseOrders = async (page = 1, applyFilters = true) => {
//         try {
//             setLoading(true);
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             // Build params
//             let params = { page };

//             if (applyFilters) {
//                 if (filters.dateRange.from) params.from_date = filters.dateRange.from;
//                 if (filters.dateRange.to) params.to_date = filters.dateRange.to;
//                 if (filters.vendorId) params.vendor_id = filters.vendorId;
//                 if (filters.searchQuery) params.search = filters.searchQuery;
//             }

//             const response = await axios.get(`${backendUrl}/api/purchase-order`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 params
//             });

//             // Normalize Laravel pagination format
//             const po = response.data.purchaseorders;

//             // Fix product item details
//             const orders = (po.data || []).map(order => ({
//                 ...order,
//                 productItemDetails: order.product_item_details || [],
//             }));

//             setPurchaseOrders(orders);

//             // Laravel pagination fields
//             setPageCount(po.last_page);
//             setCurrentPage(po.current_page);

//         } catch (error) {
//             console.error("Error fetching purchase orders:", error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Failed to load purchase orders',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Apply filters handler
//     const applyFilters = () => {
//         fetchPurchaseOrders(1, true);
//     };
//     const handlePageChange = (selectedItem) => {
//         const newPage = selectedItem.selected + 1;
//         fetchPurchaseOrders(newPage);
//     };

//     // Pagination handler
//     const handlePageClick = (data) => {
//         const selectedPage = data.selected + 1;
//         fetchPurchaseOrders(selectedPage, true);
//     };

//     // Format currency
//     const formatAmount = (amount) => {
//         if (amount === null || amount === undefined || amount === '') return '0.00';

//         const num = parseFloat(amount);
//         if (isNaN(num)) return '0.00';

//         return num.toLocaleString('en-US', {
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2
//         });
//     };

//     // Helper to get product details consistently
//     const getProductDetails = (order) => {
//         return order.productItemDetails || [];
//     };

//     // Check if PO was created from expense
//     const isPOFromExpense = (order) => {
//         const productDetails = getProductDetails(order);

//         if (productDetails.length > 0) {
//             const firstItem = productDetails[0];

//             // Check if this is an expense PO
//             const productableType = firstItem.productable_type || firstItem.productableType;
//             if (productableType === 'App\\Models\\ProjectExpense') {
//                 return true;
//             }

//             // Additional check: Look for patterns in item name/description
//             const itemName = firstItem.item_name || firstItem.itemName || '';
//             if (itemName.includes('Expense Payment')) {
//                 return true;
//             }
//         }

//         return false;
//     };

//     // Get expense details from PO (if created from expense)
//     const getExpenseDetailsFromPO = (order) => {
//         const productDetails = getProductDetails(order);

//         if (productDetails.length === 0) {
//             return null;
//         }

//         // Look for expense-linked product item
//         const expenseItem = productDetails.find(item => {
//             const productableType = item.productable_type || item.productableType;
//             return productableType === 'App\\Models\\ProjectExpense';
//         });

//         return expenseItem || productDetails[0];
//     };

//     // Calculate VAT amount
//     // const calculateVAT = (order) => {
//     //     const expenseItem = getExpenseDetailsFromPO(order);

//     //     if (expenseItem) {
//     //         // For expense POs, check tax amount
//     //         return parseFloat(expenseItem.tax || 0);
//     //     }

//     //     // For regular POs
//     //     if (order.total_vat) return parseFloat(order.total_vat);

//     //     const amount = parseFloat(order.base_amount || order.total_amount || 0);
//     //     const vatPercentage = order.vat_percentage || 5;
//     //     return (amount * vatPercentage) / 100;
//     // };

//     // // Calculate VAT percentage
//     // const calculateVATPercentage = (order) => {
//     //     const expenseItem = getExpenseDetailsFromPO(order);

//     //     if (expenseItem) {
//     //         const taxAmount = parseFloat(expenseItem.tax || 0);
//     //         const price = parseFloat(expenseItem.price || 0);
//     //         if (taxAmount > 0 && price > 0) {
//     //             return Math.round((taxAmount / price) * 100);
//     //         }
//     //         return 0;
//     //     }

//     //     return order.vat_percentage || 5;
//     // };

//     // // Calculate total with VAT
//     // const calculateTotalWithVAT = (order) => {
//     //     const amount = parseFloat(order.total_amount || order.base_amount || 0);
//     //     const vatAmount = calculateVAT(order);
//     //     return amount + vatAmount;
//     // };

//     // Determine if VAT should be shown
//     // const shouldShowVAT = (order) => {
//     //     const expenseItem = getExpenseDetailsFromPO(order);

//     //     if (expenseItem) {
//     //         const taxAmount = parseFloat(expenseItem.tax || 0);
//     //         return taxAmount > 0;
//     //     }

//     //     return true;
//     // };

//     // Get display amount (base amount)
//     // const getDisplayAmount = (order) => {
//     //     const expenseItem = getExpenseDetailsFromPO(order);

//     //     if (expenseItem) {
//     //         return parseFloat(expenseItem.price || 0);
//     //     }

//     //     return parseFloat(order.base_amount || order.amount || 0);
//     // };
//     // Replace these functions in your component:

//     // Replace ALL calculation functions with these:

//     // Helper to check if PO is custom (not from expense)
//     const isCustomPO = (order) => {
//         const productDetails = getProductDetails(order);
//         if (productDetails.length === 0) return false;

//         const firstItem = productDetails[0];
//         const productableType = firstItem.productable_type || firstItem.productableType;

//         // Check if it's a custom PO (not linked to expense)
//         return productableType === 'custom' || productableType === null || productableType === undefined;
//     };

//     // Calculate VAT amount - FIXED VERSION
//     const calculateVAT = (order) => {
//         // First, check if it's a custom PO
//         if (isCustomPO(order)) {
//             // For custom POs, use total_vat field from order
//             if (order.total_vat) {
//                 return parseFloat(order.total_vat);
//             }
//             return 0;
//         } else {
//             // For expense POs, calculate from product items
//             const productDetails = getProductDetails(order);
//             let totalTax = 0;
//             productDetails.forEach(item => {
//                 totalTax += parseFloat(item.tax || 0);
//             });
//             return totalTax;
//         }
//     };

//     // Calculate VAT percentage - FIXED VERSION
//     const calculateVATPercentage = (order) => {
//         // First, check if it's a custom PO
//         if (isCustomPO(order)) {
//             // For custom POs, calculate from order fields
//             const vatAmount = parseFloat(order.total_vat || 0);
//             const baseAmount = parseFloat(order.base_amount || 0);

//             if (vatAmount > 0 && baseAmount > 0) {
//                 const percentage = (vatAmount / baseAmount) * 100;
//                 return Math.round(percentage);
//             }
//             return 0;
//         } else {
//             // For expense POs, calculate from product items
//             const productDetails = getProductDetails(order);
//             let totalPrice = 0;
//             let totalTax = 0;

//             productDetails.forEach(item => {
//                 totalPrice += parseFloat(item.price || 0);
//                 totalTax += parseFloat(item.tax || 0);
//             });

//             if (totalTax > 0 && totalPrice > 0) {
//                 const percentage = (totalTax / totalPrice) * 100;
//                 return Math.round(percentage);
//             }
//             return 0;
//         }
//     };

//     // Get display amount (base amount) - FIXED VERSION
//     const getDisplayAmount = (order) => {
//         // First, check if it's a custom PO
//         if (isCustomPO(order)) {
//             // For custom POs, use base_amount from order
//             return parseFloat(order.base_amount || 0);
//         } else {
//             // For expense POs, sum up item prices
//             const productDetails = getProductDetails(order);
//             let totalPrice = 0;
//             productDetails.forEach(item => {
//                 totalPrice += parseFloat(item.price || 0);
//             });
//             return totalPrice;
//         }
//     };

//     // Calculate total with VAT - FIXED VERSION
//     const calculateTotalWithVAT = (order) => {
//         const baseAmount = getDisplayAmount(order);
//         const vatAmount = calculateVAT(order);
//         return baseAmount + vatAmount;
//     };

//     // Determine if VAT should be shown - FIXED VERSION
//     const shouldShowVAT = (order) => {
//         const vatAmount = calculateVAT(order);
//         return vatAmount > 0;
//     };

//     // Status badge component
//     const StatusBadge = ({ status }) => {
//         const statusConfig = {
//             'vendor_PO_generated': { label: 'Generated', class: 'primary' },
//             'approved': { label: 'Approved', class: 'success' },
//             'pending': { label: 'Pending', class: 'warning' },
//             'rejected': { label: 'Rejected', class: 'danger' },
//             'completed': { label: 'Completed', class: 'info' },
//             'vendor_payment_released': { label: 'Paid', class: 'success' }
//         };

//         const config = statusConfig[status] || { label: status, class: 'secondary' };

//         return <span className={`badge bg-${config.class}`}>{config.label}</span>;
//     };

//     // Get document preview component
//     const DocumentPreview = ({ documentPath }) => {
//         if (!documentPath) return null;

//         const backendUrl = process.env.REACT_APP_BACKEND_URL;
//         const fileUrl = `${backendUrl}/storage/${documentPath}`;
//         const fileExtension = documentPath.split('.').pop().toLowerCase();

//         if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
//             return (
//                 <img
//                     src={fileUrl}
//                     alt="Document Preview"
//                     style={{ maxWidth: '100%', maxHeight: '400px' }}
//                 />
//             );
//         } else if (fileExtension === 'pdf') {
//             return (
//                 <iframe
//                     src={fileUrl}
//                     style={{ width: '100%', height: '500px', border: 'none' }}
//                     title="PDF Preview"
//                 />
//             );
//         } else {
//             return (
//                 <div className="text-center">
//                     <FaFileInvoice size={48} className="mb-2" />
//                     <p>Preview not available for this file type</p>
//                     <a href={fileUrl} target="_blank" rel="noopener noreferrer">
//                         Download Document
//                     </a>
//                 </div>
//             );
//         }
//     };

//     // Modal handlers
//     const handleShowModal = (poId = null) => {
//         if (poId) {
//             const purchaseorderToEdit = purchaseOrders.find(purchaseorder => purchaseorder.id === poId);
//             if (purchaseorderToEdit) {
//                 setSelectedPurchaseOrderData(purchaseorderToEdit);
//             }
//         } else {
//             setSelectedPurchaseOrderData(null);
//         }
//         setSelectedPurchaseOrderId(poId);
//         setShowModal(true);
//     };

//     const handleCloseModal = () => {
//         setShowModal(false);
//         setSelectedPurchaseOrderId(null);
//         setSelectedPurchaseOrderData(null);
//     };

//     const handleSuccess = () => {
//         handleCloseModal();
//         fetchPurchaseOrders(pagination.currentPage, true);
//         Swal.fire({
//             toast: true,
//             position: 'top-end',
//             icon: 'success',
//             title: selectedPurchaseOrderId ? 'Purchase order updated successfully!' : 'Purchase order created successfully!',
//             timer: 3000,
//             showConfirmButton: false,
//         });
//     };

//     // Handle upload document
//     const handleShowUploadModal = (poId) => {
//         setSelectedPurchaseOrderId(poId);
//         setShowUploadModal(true);
//         setUploadFile(null);
//     };

//     const handleCloseUploadModal = () => {
//         setShowUploadModal(false);
//         setSelectedPurchaseOrderId(null);
//         setUploadFile(null);
//     };

//     const handleFileChange = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             // Validate file type
//             const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'];
//             if (!validTypes.includes(file.type)) {
//                 Swal.fire({
//                     toast: true,
//                     position: 'top-end',
//                     icon: 'error',
//                     title: 'Please select a valid file (JPEG, PNG, GIF, PDF)',
//                     timer: 3000,
//                     showConfirmButton: false,
//                 });
//                 e.target.value = '';
//                 return;
//             }

//             // Validate file size (5MB limit)
//             if (file.size > 5 * 1024 * 1024) {
//                 Swal.fire({
//                     toast: true,
//                     position: 'top-end',
//                     icon: 'error',
//                     title: 'File size should be less than 5MB',
//                     timer: 3000,
//                     showConfirmButton: false,
//                 });
//                 e.target.value = '';
//                 return;
//             }

//             setUploadFile(file);
//         }
//     };

//     const handleUploadSubmit = async () => {
//         if (!uploadFile) {
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Please select a file to upload',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });
//             return;
//         }

//         setUploadLoading(true);
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const formData = new FormData();
//             formData.append('document', uploadFile);

//             await axios.post(`${backendUrl}/api/purchase-order/${selectedPurchaseOrderId}/upload`, formData, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                     'Content-Type': 'multipart/form-data',
//                 },
//             });

//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'success',
//                 title: 'Document uploaded successfully!',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });

//             handleCloseUploadModal();
//             fetchPurchaseOrders(pagination.currentPage, true);
//         } catch (error) {
//             console.error('Error uploading document:', error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Failed to upload document',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });
//         } finally {
//             setUploadLoading(false);
//         }
//     };

//     // Handle edit PO details
//     const handleShowEditModal = (po) => {
//         setSelectedPurchaseOrderId(po.id);
//         setEditFormData({
//             ref_no: po.ref_no || '',
//             amount: po.amount || po.total_amount || po.base_amount || ''
//         });
//         setEditErrors({});
//         setShowEditModal(true);
//     };

//     const handleCloseEditModal = () => {
//         setShowEditModal(false);
//         setSelectedPurchaseOrderId(null);
//         setEditFormData({ ref_no: '', amount: '' });
//         setEditErrors({});
//     };

//     const validateEditForm = () => {
//         const errors = {};

//         if (!editFormData.ref_no.trim()) {
//             errors.ref_no = 'Reference number is required';
//         }

//         if (!editFormData.amount || parseFloat(editFormData.amount) <= 0) {
//             errors.amount = 'Amount must be greater than 0';
//         }

//         return errors;
//     };

//     const handleEditSubmit = async () => {
//         const errors = validateEditForm();
//         if (Object.keys(errors).length > 0) {
//             setEditErrors(errors);
//             return;
//         }

//         setEditLoading(true);
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             // Check if ref_no already exists (excluding current PO)
//             const checkResponse = await axios.get(`${backendUrl}/api/purchase-order/check-ref-no`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 params: {
//                     ref_no: editFormData.ref_no,
//                     exclude_id: selectedPurchaseOrderId
//                 }
//             });

//             if (checkResponse.data.exists) {
//                 setEditErrors({ ref_no: 'This reference number already exists' });
//                 setEditLoading(false);
//                 return;
//             }

//             // Update PO
//             await axios.put(`${backendUrl}/api/purchase-order/${selectedPurchaseOrderId}/update-details`, editFormData, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'success',
//                 title: 'Purchase order updated successfully!',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });

//             handleCloseEditModal();
//             fetchPurchaseOrders(pagination.currentPage, true);
//         } catch (error) {
//             console.error('Error updating PO:', error);

//             if (error.response?.status === 422) {
//                 // Handle validation errors from backend
//                 const backendErrors = error.response.data.errors || {};
//                 setEditErrors(backendErrors);

//                 if (backendErrors.ref_no) {
//                     Swal.fire({
//                         toast: true,
//                         position: 'top-end',
//                         icon: 'error',
//                         title: backendErrors.ref_no[0],
//                         timer: 3000,
//                         showConfirmButton: false,
//                     });
//                 }
//             } else {
//                 Swal.fire({
//                     toast: true,
//                     position: 'top-end',
//                     icon: 'error',
//                     title: 'Failed to update purchase order',
//                     timer: 3000,
//                     showConfirmButton: false,
//                 });
//             }
//         } finally {
//             setEditLoading(false);
//         }
//     };

//     // Delete purchase order
//     const deletePurchaseOrder = async (id) => {
//         const result = await Swal.fire({
//             title: "Are you sure?",
//             text: "You won't be able to revert this!",
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonColor: "#d33",
//             cancelButtonColor: "#3085d6",
//             confirmButtonText: "Yes, delete it!",
//             cancelButtonText: "Cancel"
//         });

//         if (!result.isConfirmed) return;

//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             await axios.delete(`${backendUrl}/api/purchase-order/${id}`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             // Refresh the list
//             fetchPurchaseOrders(pagination.currentPage, true);

//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'success',
//                 title: 'Purchase order deleted successfully!',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });
//         } catch (error) {
//             console.error('Error deleting purchase order:', error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Failed to delete purchase order',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });
//         }
//     };

//     // Export functionality
//     const handleExport = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             // Build export parameters based on current filters
//             const exportParams = new URLSearchParams();

//             if (filters.dateRange.from) exportParams.append('from_date', filters.dateRange.from);
//             if (filters.dateRange.to) exportParams.append('to_date', filters.dateRange.to);
//             if (filters.vendorId) exportParams.append('vendor_id', filters.vendorId);
//             if (filters.searchQuery) exportParams.append('search', filters.searchQuery);

//             const response = await axios.get(`${backendUrl}/api/purchase-order/export?${exportParams.toString()}`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 responseType: 'blob'
//             });

//             // Create download link
//             const url = window.URL.createObjectURL(new Blob([response.data]));
//             const link = document.createElement('a');
//             link.href = url;

//             // Get filename from response headers or use default
//             const contentDisposition = response.headers['content-disposition'];
//             let filename = `purchase_orders_export_${new Date().toISOString().split('T')[0]}.xlsx`;

//             if (contentDisposition) {
//                 const filenameMatch = contentDisposition.match(/filename="(.+)"/);
//                 if (filenameMatch) {
//                     filename = filenameMatch[1];
//                 }
//             }

//             link.setAttribute('download', filename);
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//             window.URL.revokeObjectURL(url);

//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'success',
//                 title: 'Purchase orders exported successfully!',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });

//         } catch (error) {
//             console.error('Export error:', error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Failed to export purchase orders',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });
//         }
//     };

//     // Import functionality
//     const handleImport = async (event) => {
//         const file = event.target.files[0];
//         if (!file) return;

//         // Validate file type
//         const validTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'];
//         if (!validTypes.includes(file.type)) {
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Please select a valid Excel or CSV file',
//                 timer: 3000,
//                 showConfirmButton: false,
//             });
//             return;
//         }

//         const result = await Swal.fire({
//             title: 'Import Purchase Orders',
//             text: 'Are you sure you want to import purchase orders from this file?',
//             icon: 'question',
//             showCancelButton: true,
//             confirmButtonColor: '#3085d6',
//             cancelButtonColor: '#d33',
//             confirmButtonText: 'Yes, import!',
//             cancelButtonText: 'Cancel'
//         });

//         if (!result.isConfirmed) {
//             event.target.value = '';
//             return;
//         }

//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const formData = new FormData();
//             formData.append('file', file);

//             const response = await axios.post(`${backendUrl}/api/purchase-order/import`, formData, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                     'Content-Type': 'multipart/form-data',
//                 },
//             });

//             const result = response.data;

//             let message = `Import completed successfully!<br>
//                           Imported: ${result.imported_count || result.count || 0}`;

//             if (result.errors && result.errors.length > 0) {
//                 message += `<br><br>Errors:<br>${result.errors.join('<br>')}`;
//             }

//             Swal.fire({
//                 title: 'Import Result',
//                 html: message,
//                 icon: 'success',
//                 confirmButtonText: 'OK'
//             });

//             // Refresh the list
//             fetchPurchaseOrders(1, true);

//         } catch (error) {
//             console.error('Import error:', error);
//             let errorMessage = 'Failed to import purchase orders';

//             if (error.response?.data?.message) {
//                 errorMessage = error.response.data.message;
//             } else if (error.message) {
//                 errorMessage = error.message;
//             }

//             Swal.fire({
//                 title: 'Import Failed',
//                 text: errorMessage,
//                 icon: 'error',
//                 confirmButtonText: 'OK'
//             });
//         } finally {
//             event.target.value = '';
//         }
//     };

//     // Initial data loading
//     useEffect(() => {
//         fetchVendors();
//         fetchPurchaseOrders(1, false);
//     }, []);

//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     {/* Header */}
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                                 <h4 className="mb-sm-0 font-size-18">Purchase Orders</h4>
//                                 <div className="page-title-right">
//                                     <WithCreatePermission>
//                                         <button
//                                             className="btn btn-primary"
//                                             onClick={() => handleShowModal()}
//                                         >
//                                             <FaPlus className="me-1" />
//                                             Add Purchase Order
//                                         </button>
//                                     </WithCreatePermission>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Filter Panel */}
//                     <div className="card filter-card mb-4">
//                         <div className="card-body">
//                             <h5 className="card-title mb-3">
//                                 <FaFilter className="me-2" />
//                                 Filter Purchase Orders
//                             </h5>

//                             <div className="row g-3">
//                                 {/* Date Filters */}
//                                 <div className="col-md-3">
//                                     <label className="form-label">From Date</label>
//                                     <input
//                                         type="date"
//                                         className="form-control"
//                                         value={filters.dateRange.from}
//                                         onChange={(e) => updateFilter('dateRange', { ...filters.dateRange, from: e.target.value })}
//                                     />
//                                 </div>

//                                 <div className="col-md-3">
//                                     <label className="form-label">To Date</label>
//                                     <input
//                                         type="date"
//                                         className="form-control"
//                                         value={filters.dateRange.to}
//                                         onChange={(e) => updateFilter('dateRange', { ...filters.dateRange, to: e.target.value })}
//                                     />
//                                 </div>

//                                 {/* Vendor Filter */}
//                                 <div className="col-md-3">
//                                     <label className="form-label">Vendor</label>
//                                     <select
//                                         className="form-select"
//                                         value={filters.vendorId}
//                                         onChange={(e) => updateFilter('vendorId', e.target.value)}
//                                     >
//                                         <option value="">All Vendors</option>
//                                         {vendors.map(vendor => (
//                                             <option key={vendor.id} value={vendor.id}>
//                                                 {vendor.name || vendor.business_name || `Vendor ${vendor.id}`}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 {/* Search */}
//                                 <div className="col-md-3">
//                                     <label className="form-label">Search</label>
//                                     <div className="input-group">
//                                         <span className="input-group-text">
//                                             <FaSearch />
//                                         </span>
//                                         <input
//                                             type="text"
//                                             className="form-control"
//                                             placeholder="Search by reference no..."
//                                             value={filters.searchQuery}
//                                             onChange={(e) => updateFilter('searchQuery', e.target.value)}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Action Buttons */}
//                             <div className="row g-3 mt-2">
//                                 <div className="col-md-12 d-flex align-items-end justify-content-between">
//                                     <div>
//                                         <button
//                                             className="btn btn-primary me-2"
//                                             onClick={applyFilters}
//                                         >
//                                             Apply Filters
//                                         </button>
//                                         <button
//                                             className="btn btn-outline-secondary me-2"
//                                             onClick={resetFilters}
//                                         >
//                                             Clear All
//                                         </button>
//                                     </div>
//                                     <div className="d-flex align-items-center gap-2">
//                                         <button
//                                             type="button"
//                                             className="btn btn-light border"
//                                             onClick={handleExport}
//                                             data-bs-toggle="tooltip"
//                                             data-bs-placement="top"
//                                             title="Export to Excel"
//                                         >
//                                             <FaFileExcel className="text-success" />
//                                         </button>

//                                         <input
//                                             type="file"
//                                             accept=".xlsx, .xls, .csv"
//                                             id="importFile"
//                                             onChange={handleImport}
//                                             style={{ display: "none" }}
//                                         />
//                                         <label
//                                             htmlFor="importFile"
//                                             className="btn btn-light border mb-0"
//                                             data-bs-toggle="tooltip"
//                                             data-bs-placement="top"
//                                             title="Import from Excel"
//                                         >
//                                             <FaUpload className="text-primary" />
//                                         </label>

//                                         <button
//                                             className="btn btn-outline-primary"
//                                             onClick={() => fetchPurchaseOrders(1, true)}
//                                         >
//                                             <FaSync className="me-1" /> Refresh
//                                         </button>

//                                         <div className="text-muted ms-3">
//                                             <small>
//                                                 Showing {purchaseOrders.length} of {pagination.total} records
//                                             </small>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Purchase Orders Table */}
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="card">
//                                 <div className="card-body">
//                                     <div className="d-flex justify-content-between align-items-center mb-3">
//                                         <h5 className="card-title mb-0">Purchase Orders</h5>
//                                     </div>

//                                     <div className="table-responsive">
//                                         <table className="table align-middle table-nowrap table-hover">
//                                             <thead className="table-sales-gradient">
//                                                 <tr>
//                                                     <th>#</th>
//                                                     <th>Client</th>
//                                                     <th>Project</th>
//                                                     <th>Vendor Name</th>
//                                                     <th>Reference No</th>

//                                                     <th>Date</th>
//                                                     <th>Amount</th>
//                                                     <th>VAT</th>
//                                                     <th>VAT Amount</th>
//                                                     <th>Total with VAT</th>
//                                                     <th>Status</th>
//                                                     <th>Actions</th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 {purchaseOrders.length > 0 ? (
//                                                     purchaseOrders.map((order, index) => {
//                                                         const isExpensePO = isPOFromExpense(order);
//                                                         const showVAT = shouldShowVAT(order);
//                                                         const vatPercentage = calculateVATPercentage(order);
//                                                         const vatAmount = calculateVAT(order);
//                                                         const displayAmount = getDisplayAmount(order);
//                                                         const totalWithVAT = calculateTotalWithVAT(order);
//                                                         const hasDocument = order.document;

//                                                         return (
//                                                             <tr key={order.id}>
//                                                                 <td>{index + 1}</td>
//                                                                 <td>{order.client?.name || ''}</td>
//                                                                 <td>{order?.project?.name || ''}</td>
//                                                                 <td>
//                                                                     {order.vendor?.name || ''}
//                                                                 </td>
//                                                                 <td>
//                                                                     {order.ref_no}

//                                                                 </td>

//                                                                 <td>
//                                                                     {new Date(order.date).toLocaleDateString()}
//                                                                 </td>


//                                                                 <td>
//                                                                     {formatAmount(displayAmount)}
//                                                                 </td>
//                                                                 <td>
//                                                                     {showVAT ? (
//                                                                         `${vatPercentage}%`
//                                                                     ) : null
//                                                                     }
//                                                                 </td>
//                                                                 <td>
//                                                                     {showVAT ? (
//                                                                         formatAmount(vatAmount)
//                                                                     ) : null}
//                                                                 </td>
//                                                                 <td>
//                                                                     {showVAT ? (
//                                                                         formatAmount(totalWithVAT)

//                                                                     ) : (
//                                                                         formatAmount(displayAmount)
//                                                                     )}
//                                                                     <span className="text-muted ms-1 font-size-11">({(order?.vendor?.currency)})</span>

//                                                                 </td>
//                                                                 <td>
//                                                                     <StatusBadge status={order.po_status} />
//                                                                 </td>

//                                                                 <td>
//                                                                     <div className="dropdown">
//                                                                         <i
//                                                                             className="mdi mdi-dots-horizontal font-size-18"
//                                                                             data-bs-toggle="dropdown"
//                                                                             aria-expanded="false"
//                                                                             style={{ cursor: "pointer" }}
//                                                                         ></i>
//                                                                         <ul className="dropdown-menu">
//                                                                             <li>
//                                                                                 <button
//                                                                                     className="dropdown-item"
//                                                                                     onClick={() => handleShowModal(order.id)}
//                                                                                 >
//                                                                                     <FaEye className="me-2" />
//                                                                                     View Details
//                                                                                 </button>
//                                                                             </li>
//                                                                             <WithEditPermission>
//                                                                                 <li>
//                                                                                     <button
//                                                                                         className="dropdown-item"
//                                                                                         onClick={() => handleShowModal(order.id)}
//                                                                                     >
//                                                                                         <FaEdit className="me-2" />
//                                                                                         Edit Details
//                                                                                     </button>
//                                                                                 </li>
//                                                                                 <li>
//                                                                                     <button
//                                                                                         className="dropdown-item"
//                                                                                         onClick={() => handleShowUploadModal(order.id)}
//                                                                                     >
//                                                                                         <FaUpload className="me-2" />
//                                                                                         {hasDocument ? 'Replace Document' : 'Upload Document'}
//                                                                                     </button>
//                                                                                 </li>
//                                                                             </WithEditPermission>
//                                                                             <WithDeletePermission>
//                                                                                 <li>
//                                                                                     <button
//                                                                                         className="dropdown-item text-danger"
//                                                                                         onClick={() => deletePurchaseOrder(order.id)}
//                                                                                     >
//                                                                                         <FaTrash className="me-2" />
//                                                                                         Delete
//                                                                                     </button>
//                                                                                 </li>
//                                                                             </WithDeletePermission>
//                                                                         </ul>
//                                                                     </div>
//                                                                 </td>
//                                                             </tr>
//                                                         );
//                                                     })
//                                                 ) : (
//                                                     <tr>
//                                                         <td colSpan="11" className="text-center py-4">
//                                                             <div className="text-muted">
//                                                                 <FaFileInvoice size={48} className="mb-2" />
//                                                                 <p>No purchase orders found</p>
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 )}
//                                             </tbody>
//                                         </table>
//                                     </div>

//                                     {/* Pagination */}
//                                     <div className="d-flex justify-content-end pagination-sm">
//                                         <ReactPaginate
//                                             previousLabel={'<'}
//                                             nextLabel={'>'}
//                                             breakLabel={'...'}
//                                             pageCount={pageCount}
//                                             marginPagesDisplayed={2}
//                                             pageRangeDisplayed={3}
//                                             onPageChange={handlePageChange}
//                                             containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
//                                             pageClassName={'page-item'}
//                                             pageLinkClassName={'page-link'}
//                                             previousClassName={'page-item previous'}
//                                             previousLinkClassName={'page-link'}
//                                             nextClassName={'page-item next'}
//                                             nextLinkClassName={'page-link'}
//                                             breakClassName={'page-item'}
//                                             breakLinkClassName={'page-link'}
//                                             activeClassName={'active'}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Purchase Order Modal */}
//             <PurchaseOrderForm
//                 showModal={showModal}
//                 handleClose={handleCloseModal}
//                 poId={selectedPurchaseOrderId}
//                 purchaseorderData={selectedPurchaseOrderData}
//                 onSuccess={handleSuccess}
//                 vendors={vendors}
//             />

//             {/* Upload Document Modal */}
//             <Offcanvas show={showUploadModal} onHide={handleCloseUploadModal} placement="end" style={{ width: '600px' }}>
//                 <Offcanvas.Header closeButton>
//                     <Offcanvas.Title>
//                         <FaUpload className="me-2" />
//                         Upload Document
//                     </Offcanvas.Title>
//                 </Offcanvas.Header>
//                 <Offcanvas.Body>
//                     <div className="mb-3">
//                         <Form.Label>Select Document</Form.Label>
//                         <Form.Control
//                             type="file"
//                             accept=".jpg,.jpeg,.png,.gif,.pdf"
//                             onChange={handleFileChange}
//                         />
//                         <Form.Text className="text-muted">
//                             Supported formats: JPG, PNG, GIF, PDF (Max 5MB)
//                         </Form.Text>
//                     </div>

//                     {uploadFile && (
//                         <div className="mb-3">
//                             <div className="d-flex justify-content-between align-items-center mb-2">
//                                 <Form.Label>Selected File</Form.Label>
//                                 <Button
//                                     variant="link"
//                                     size="sm"
//                                     onClick={() => setUploadFile(null)}
//                                     className="text-danger"
//                                 >
//                                     <FaTimes /> Remove
//                                 </Button>
//                             </div>
//                             <div className="border rounded p-3">
//                                 <div className="d-flex align-items-center">
//                                     {uploadFile.type.startsWith('image/') ? (
//                                         <FaFileImage className="me-2 text-primary" size={24} />
//                                     ) : (
//                                         <FaFilePdf className="me-2 text-danger" size={24} />
//                                     )}
//                                     <div>
//                                         <strong>{uploadFile.name}</strong>
//                                         <div className="text-muted small">
//                                             {(uploadFile.size / 1024 / 1024).toFixed(2)} MB
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     )}

//                     {selectedPurchaseOrderId && purchaseOrders.find(po => po.id === selectedPurchaseOrderId)?.document && (
//                         <div className="mb-3">
//                             <Form.Label>Current Document</Form.Label>
//                             <DocumentPreview
//                                 documentPath={purchaseOrders.find(po => po.id === selectedPurchaseOrderId)?.document}
//                             />
//                         </div>
//                     )}
//                 </Offcanvas.Body>
//                 <div className="p-3 border-top">
//                     <div className="d-flex justify-content-end gap-2">
//                         <Button variant="secondary" onClick={handleCloseUploadModal}>
//                             Cancel
//                         </Button>
//                         <Button
//                             variant="primary"
//                             onClick={handleUploadSubmit}
//                             disabled={!uploadFile || uploadLoading}
//                         >
//                             {uploadLoading ? (
//                                 <>
//                                     <Spinner animation="border" size="sm" className="me-2" />
//                                     Uploading...
//                                 </>
//                             ) : (
//                                 'Upload Document'
//                             )}
//                         </Button>
//                     </div>
//                 </div>
//             </Offcanvas>

//         </div>
//     );
// };

// export default PODetails;


import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import {
    FaFilter,
    FaSearch,
    FaSync,
    FaFileInvoice,
    FaDownload,
    FaUpload,
    FaFileExcel,
    FaEye,
    FaEdit,
    FaTrash,
    FaPlus,
    FaPaperclip,
    FaFilePdf,
    FaFileImage,
    FaTimes
} from 'react-icons/fa';
import Swal from 'sweetalert2';
import { Button, Form, Row, Col, Card, Table, Badge, Offcanvas, Modal, Spinner } from 'react-bootstrap';
import withPermission from '../../utils/withPermission';
import PurchaseOrderForm from '../purchaseorder/PurchaseOrderForm';

const PODetails = () => {
    // State management
    const [purchaseOrders, setPurchaseOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [vendors, setVendors] = useState([]);
    const [clients, setClients] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedPurchaseOrderId, setSelectedPurchaseOrderId] = useState(null);
    const [selectedPurchaseOrderData, setSelectedPurchaseOrderData] = useState(null);

    // New states for upload and edit features
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [uploadFile, setUploadFile] = useState(null);
    const [uploadLoading, setUploadLoading] = useState(false);
    const [editFormData, setEditFormData] = useState({ ref_no: '', amount: '' });
    const [editLoading, setEditLoading] = useState(false);
    const [editErrors, setEditErrors] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    // Document-preview offcanvas state
    const [showDocOffcanvas, setShowDocOffcanvas] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [selectedPOForDoc, setSelectedPOForDoc] = useState(null);

    // View Details offcanvas state
    const [showViewOffcanvas, setShowViewOffcanvas] = useState(false);
    const [selectedViewPO, setSelectedViewPO] = useState(null);
    const [viewPOLoading, setViewPOLoading] = useState(false);

    // Pagination state
    const [pagination, setPagination] = useState({
        currentPage: 1,
        pageCount: 0,
        total: 0
    });

    // Filter state
    const [filters, setFilters] = useState({
        dateRange: { from: '', to: '' },
        vendorId: '',
        clientId: '',
        searchQuery: ''
    });

    // Permission hooks
    const WithEditPermission = withPermission(({ children }) => children, ['purchaseorder-edit']);
    const WithDeletePermission = withPermission(({ children }) => children, ['purchaseorder-delete']);
    const WithCreatePermission = withPermission(({ children }) => children, ['purchaseorder-create']);

    // Filter handlers
    const updateFilter = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
    };

    const resetFilters = () => {
        setFilters({
            dateRange: { from: '', to: '' },
            vendorId: '',
            clientId: '',
            searchQuery: ''
        });
        fetchPurchaseOrders(1);
    };

    // Data fetching functions
    const fetchVendors = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/contacts?type=vendor`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            setVendors(response.data.Data || []);
        } catch (error) {
            console.error("Error fetching vendors:", error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to fetch vendors',
                timer: 3000,
                showConfirmButton: false,
            });
        }
    };

    const fetchClients = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/contacts?type=client`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            setClients(response.data.Data || []);
        } catch (error) {
            console.error("Error fetching clients:", error);
        }
    };

    const fetchPurchaseOrders = async (page = 1, applyFilters = true) => {
        try {
            setLoading(true);
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Build params
            let params = { page };

            if (applyFilters) {
                if (filters.dateRange.from) params.from_date = filters.dateRange.from;
                if (filters.dateRange.to) params.to_date = filters.dateRange.to;
                if (filters.vendorId) params.vendor_id = filters.vendorId;
                if (filters.clientId) params.client_id = filters.clientId;
                if (filters.searchQuery) params.search = filters.searchQuery;
            }

            const response = await axios.get(`${backendUrl}/api/purchase-order`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params
            });

            // Normalize Laravel pagination format
            const po = response.data.purchaseorders || response.data?.data || response.data;
            
            let orderList = [];
            if (Array.isArray(po)) {
                orderList = po;
            } else if (po.data && Array.isArray(po.data)) {
                orderList = po.data;
            }

            // Fix product item details
            const orders = orderList.map(order => ({
                ...order,
                productItemDetails: order.productItemDetails || order.product_item_details || [],
            }));

            setPurchaseOrders(orders);

            // Laravel pagination fields
            setPageCount(po.last_page || 1);
            setCurrentPage(po.current_page || 1);

        } catch (error) {
            console.error("Error fetching purchase orders:", error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to load purchase orders',
                timer: 3000,
                showConfirmButton: false,
            });
        } finally {
            setLoading(false);
        }
    };

    // Apply filters handler
    const applyFilters = () => {
        fetchPurchaseOrders(1, true);
    };
    const handlePageChange = (selectedItem) => {
        const newPage = selectedItem.selected + 1;
        fetchPurchaseOrders(newPage);
    };

    // Pagination handler
    const handlePageClick = (data) => {
        const selectedPage = data.selected + 1;
        fetchPurchaseOrders(selectedPage, true);
    };

    // Format currency
    const formatAmount = (amount) => {
        if (amount === null || amount === undefined || amount === '') return '0.00';

        const num = parseFloat(amount);
        if (isNaN(num)) return '0.00';

        return num.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    // Helper to get product details consistently
    const getProductDetails = (order) => {
        return order.productItemDetails || [];
    };

    // Check if PO was created from expense
    const isPOFromExpense = (order) => {
        const productDetails = getProductDetails(order);

        if (productDetails.length > 0) {
            const firstItem = productDetails[0];

            // Check if this is an expense PO
            const productableType = firstItem.productable_type || firstItem.productableType;
            if (productableType === 'App\\Models\\ProjectExpense') {
                return true;
            }

            // Additional check: Look for patterns in item name/description
            const itemName = firstItem.item_name || firstItem.itemName || '';
            if (itemName.includes('Expense Payment')) {
                return true;
            }
        }

        return false;
    };

    // Get expense details from PO (if created from expense)
    const getExpenseDetailsFromPO = (order) => {
        const productDetails = getProductDetails(order);

        if (productDetails.length === 0) {
            return null;
        }

        // Look for expense-linked product item
        const expenseItem = productDetails.find(item => {
            const productableType = item.productable_type || item.productableType;
            return productableType === 'App\\Models\\ProjectExpense';
        });

        return expenseItem || productDetails[0];
    };

    // Helper to check if PO is custom (not from expense)
    const isCustomPO = (order) => {
        const productDetails = getProductDetails(order);
        if (productDetails.length === 0) return false;

        const firstItem = productDetails[0];
        const productableType = firstItem.productable_type || firstItem.productableType;

        // Check if it's a custom PO (not linked to expense)
        return productableType === 'custom' || productableType === null || productableType === undefined;
    };

    // Calculate VAT amount - FIXED VERSION
    const calculateVAT = (order) => {
        // First, check if it's a custom PO
        if (isCustomPO(order)) {
            // For custom POs, use total_vat field from order
            if (order.total_vat) {
                return parseFloat(order.total_vat);
            }
            return 0;
        } else {
            // For expense POs, calculate from product items
            const productDetails = getProductDetails(order);
            let totalTax = 0;
            productDetails.forEach(item => {
                totalTax += parseFloat(item.tax || 0);
            });
            return totalTax;
        }
    };

    // Calculate VAT percentage - FIXED VERSION
    const calculateVATPercentage = (order) => {
        // First, check if it's a custom PO
        if (isCustomPO(order)) {
            // For custom POs, calculate from order fields
            const vatAmount = parseFloat(order.total_vat || 0);
            const baseAmount = parseFloat(order.base_amount || 0);

            if (vatAmount > 0 && baseAmount > 0) {
                const percentage = (vatAmount / baseAmount) * 100;
                return Math.round(percentage);
            }
            return 0;
        } else {
            // For expense POs, calculate from product items
            const productDetails = getProductDetails(order);
            let totalPrice = 0;
            let totalTax = 0;

            productDetails.forEach(item => {
                totalPrice += parseFloat(item.price || 0);
                totalTax += parseFloat(item.tax || 0);
            });

            if (totalTax > 0 && totalPrice > 0) {
                const percentage = (totalTax / totalPrice) * 100;
                return Math.round(percentage);
            }
            return 0;
        }
    };
    // Add this function after your other handler functions
    const handleRefNoClick = (order) => {
        if (order.document) {
            setSelectedPOForDoc(order);
            setSelectedDocument(order.document);
            setShowDocOffcanvas(true);
        } else {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'info',
                title: 'No document attached to this purchase order',
                timer: 3000,
                showConfirmButton: false,
            });
        }
    };

    // ------- View Details handlers -------
    const fetchPODetailData = async (poId) => {
        setViewPOLoading(true);
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/purchase-order/${poId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const po = response.data.purchaseorder || response.data.data || response.data;

            // Map transaction_expense_items → normalised payments array for the offcanvas
            const rawItems = po.transaction_expense_items || [];
            const payments = rawItems.map(item => ({
                voucher_id:       item.transaction_voucher_id || item.transaction?.transaction_voucher_id || item.transaction_id || item.id,
                transaction_date: item.transaction?.date || item.created_at,
                transaction_currency: item.transaction?.currency?.currency || item.transaction?.transaction_currency || 'AED',
                transaction_description: item.transaction?.description || item.transaction?.narration || item.transaction?.description_webzash || '',
                transaction_amount: parseFloat(item.transaction?.amount || 0),
                amount:           parseFloat(item.paid_amount || item.amount || 0),
                bill_no:          item.expense?.invoice_no || item.expense?.external_id || '—',
                expense_name:     item.expense?.narration || 
                                    (item.expense?.external_id ? `Expense ${item.expense.external_id}` : `Expense #${item.expense_id}`),
                balance_after:    parseFloat(item.balance_amount || 0),
                is_fully_paid:    item.is_fully_paid,
                exchange_rate:    parseFloat(item.transaction?.exchange_rate || 1.0),
                full_breakdown:   (item.transaction?.transaction_expense_items || []).map(bi => ({
                    bill_no:          bi.expense?.invoice_no || bi.expense?.external_id || '-',
                    amount:           parseFloat(bi.paid_amount || bi.amount || 0),
                    balance:          parseFloat(bi.balance_amount || 0),
                    expense_name:     bi.expense?.narration || 
                                      (bi.expense?.external_id ? `Expense ${bi.expense.external_id}` : `Expense #${bi.expense_id}`),
                })),
            }));

            setSelectedViewPO(prev => ({
                ...prev,
                ...po,
                productItemDetails: po.product_item_details || po.productItemDetails || prev?.productItemDetails || [],
                payments,
            }));
        } catch (error) {
            console.error('Error fetching PO details:', error);
        } finally {
            setViewPOLoading(false);
        }
    };

    const handleViewDetails = (order) => {
        setSelectedViewPO({
            ...order,
            productItemDetails: order.productItemDetails || order.product_item_details || [],
            payments: [],
        });
        setShowViewOffcanvas(true);
        fetchPODetailData(order.id);
    };

    const handleCloseViewOffcanvas = () => {
        setShowViewOffcanvas(false);
        setSelectedViewPO(null);
    };
    // ------- End View Details handlers -------


    // Get display amount (base amount) - FIXED VERSION
    const getDisplayAmount = (order) => {
        // If it's an auto-generated PO from expense, handle it specifically
        if (order.notes === 'Auto-generated from expense' || isPOFromExpense(order)) {
            // For auto-generated POs, order.amount or order.base_amount should be authoritative
            const amount = parseFloat(order.base_amount || order.amount || 0);
            if (amount > 0) return amount;

            // Fallback to summing items if header amount is missing
            const productDetails = getProductDetails(order);
            let totalPrice = 0;
            productDetails.forEach(item => {
                totalPrice += parseFloat(item.price || 0);
            });
            return totalPrice;
        }

        // For regular/custom POs
        if (isCustomPO(order)) {
            return parseFloat(order.base_amount || order.payable_amount || order.amount || 0);
        } else {
            const productDetails = getProductDetails(order);
            let totalPrice = 0;
            productDetails.forEach(item => {
                totalPrice += parseFloat(item.price || 0);
            });
            return totalPrice;
        }
    };

    // Calculate total with VAT - FIXED VERSION
    const calculateTotalWithVAT = (order) => {
        const baseAmount = getDisplayAmount(order);
        const vatAmount = calculateVAT(order);
        return baseAmount + vatAmount;
    };

    // Determine if VAT should be shown - FIXED VERSION
    const shouldShowVAT = (order) => {
        const vatAmount = calculateVAT(order);
        return vatAmount > 0;
    };

    // NEW: Get vendor currency
    const getVendorCurrency = (order) => {
        return order?.vendor?.currency || 'AED';
    };

    // NEW: Convert amount to AED if needed
    const convertToAED = (amount, currency) => {
        const numAmount = parseFloat(amount) || 0;

        // You might want to fetch exchange rates from an API
        // For now, using static rates
        const exchangeRates = {
            'USD': process.env.REACT_APP_EXCHANGE_RATE_USD_AED || 3.692,
            'EUR': 4.0,
            'GBP': 4.7,
            'INR': 0.044,
            'AED': 1
        };

        const rate = exchangeRates[currency] || 1;
        return numAmount * rate;
    };

    // NEW: Get used amount (allocated used amount)
    const getUsedAmount = (order) => {
        return parseFloat(order.used_amount || 0);
    };

    // NEW: Get remaining balance
    const getBalanceAmount = (order) => {
        const totalAmount = calculateTotalWithVAT(order);
        const usedAmount = getUsedAmount(order);
        return totalAmount - usedAmount;
    };

    // NEW: Get AED amount
    const getAEDAmount = (order, originalAmount) => {
        const currency = getVendorCurrency(order);
        if (currency === 'AED') {
            return parseFloat(originalAmount);
        }
        return convertToAED(originalAmount, currency);
    };

    // NEW: Calculate totals for footer
    const calculateTotals = () => {
        let totals = {
            amountAED: 0,
            vatAmountAED: 0,
            totalAmountAED: 0,
            usedAmountAED: 0,
            balanceAmountAED: 0
        };

        purchaseOrders.forEach(order => {
            const displayAmount = getDisplayAmount(order);
            const vatAmount = calculateVAT(order);
            const totalWithVAT = calculateTotalWithVAT(order);
            const usedAmount = getUsedAmount(order);
            const balanceAmount = getBalanceAmount(order);

            totals.amountAED += getAEDAmount(order, displayAmount);
            totals.vatAmountAED += getAEDAmount(order, vatAmount);
            totals.totalAmountAED += getAEDAmount(order, totalWithVAT);
            totals.usedAmountAED += getAEDAmount(order, usedAmount);
            totals.balanceAmountAED += getAEDAmount(order, balanceAmount);
        });

        return totals;
    };

    // Status badge component
    const StatusBadge = ({ status }) => {
        const statusConfig = {
            'vendor_PO_generated': { label: 'Generated', class: 'primary' },
            'approved': { label: 'Approved', class: 'success' },
            'pending': { label: 'Pending', class: 'warning' },
            'rejected': { label: 'Rejected', class: 'danger' },
            'completed': { label: 'Completed', class: 'info' },
            'vendor_payment_released': { label: 'Paid', class: 'success' }
        };

        const config = statusConfig[status] || { label: status, class: 'secondary' };

        return <span className={`badge bg-${config.class}`}>{config.label}</span>;
    };

    // Get document preview component
    const DocumentPreview = ({ documentPath }) => {
        if (!documentPath) return null;

        const backendUrl = process.env.REACT_APP_BACKEND_URL;
        const fileUrl = `${backendUrl}/storage/${documentPath}`;
        const fileExtension = documentPath.split('.').pop().toLowerCase();

        if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
            return (
                <img
                    src={fileUrl}
                    alt="Document Preview"
                    style={{ maxWidth: '100%', maxHeight: '400px' }}
                />
            );
        } else if (fileExtension === 'pdf') {
            return (
                <iframe
                    src={fileUrl}
                    style={{ width: '100%', height: '500px', border: 'none' }}
                    title="PDF Preview"
                />
            );
        } else {
            return (
                <div className="text-center">
                    <FaFileInvoice size={48} className="mb-2" />
                    <p>Preview not available for this file type</p>
                    <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                        Download Document
                    </a>
                </div>
            );
        }
    };

    // Modal handlers
    const handleShowModal = (poId = null) => {
        if (poId) {
            const purchaseorderToEdit = purchaseOrders.find(purchaseorder => purchaseorder.id === poId);
            if (purchaseorderToEdit) {
                setSelectedPurchaseOrderData(purchaseorderToEdit);
            }
        } else {
            setSelectedPurchaseOrderData(null);
        }
        setSelectedPurchaseOrderId(poId);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedPurchaseOrderId(null);
        setSelectedPurchaseOrderData(null);
    };

    const handleSuccess = () => {
        handleCloseModal();
        fetchPurchaseOrders(pagination.currentPage, true);
        Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: selectedPurchaseOrderId ? 'Purchase order updated successfully!' : 'Purchase order created successfully!',
            timer: 3000,
            showConfirmButton: false,
        });
    };

    // Handle upload document
    const handleShowUploadModal = (poId) => {
        setSelectedPurchaseOrderId(poId);
        setShowUploadModal(true);
        setUploadFile(null);
    };

    const handleCloseUploadModal = () => {
        setShowUploadModal(false);
        setSelectedPurchaseOrderId(null);
        setUploadFile(null);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Validate file type
            const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'];
            if (!validTypes.includes(file.type)) {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'Please select a valid file (JPEG, PNG, GIF, PDF)',
                    timer: 3000,
                    showConfirmButton: false,
                });
                e.target.value = '';
                return;
            }

            // Validate file size (5MB limit)
            if (file.size > 5 * 1024 * 1024) {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'File size should be less than 5MB',
                    timer: 3000,
                    showConfirmButton: false,
                });
                e.target.value = '';
                return;
            }

            setUploadFile(file);
        }
    };

    const handleUploadSubmit = async () => {
        if (!uploadFile) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Please select a file to upload',
                timer: 3000,
                showConfirmButton: false,
            });
            return;
        }

        setUploadLoading(true);
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const formData = new FormData();
            formData.append('document', uploadFile);

            await axios.post(`${backendUrl}/api/purchase-order/${selectedPurchaseOrderId}/upload`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                    'Content-Type': 'multipart/form-data',
                },
            });

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Document uploaded successfully!',
                timer: 3000,
                showConfirmButton: false,
            });

            handleCloseUploadModal();
            fetchPurchaseOrders(pagination.currentPage, true);
        } catch (error) {
            console.error('Error uploading document:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to upload document',
                timer: 3000,
                showConfirmButton: false,
            });
        } finally {
            setUploadLoading(false);
        }
    };

    // Handle edit PO details
    const handleShowEditModal = (po) => {
        setSelectedPurchaseOrderId(po.id);
        setEditFormData({
            ref_no: po.ref_no || '',
            amount: po.amount || po.total_amount || po.base_amount || ''
        });
        setEditErrors({});
        setShowEditModal(true);
    };

    const handleCloseEditModal = () => {
        setShowEditModal(false);
        setSelectedPurchaseOrderId(null);
        setEditFormData({ ref_no: '', amount: '' });
        setEditErrors({});
    };

    const validateEditForm = () => {
        const errors = {};

        if (!editFormData.ref_no.trim()) {
            errors.ref_no = 'Reference number is required';
        }

        if (!editFormData.amount || parseFloat(editFormData.amount) <= 0) {
            errors.amount = 'Amount must be greater than 0';
        }

        return errors;
    };

    const handleEditSubmit = async () => {
        const errors = validateEditForm();
        if (Object.keys(errors).length > 0) {
            setEditErrors(errors);
            return;
        }

        setEditLoading(true);
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Check if ref_no already exists (excluding current PO)
            const checkResponse = await axios.get(`${backendUrl}/api/purchase-order/check-ref-no`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: {
                    ref_no: editFormData.ref_no,
                    exclude_id: selectedPurchaseOrderId
                }
            });

            if (checkResponse.data.exists) {
                setEditErrors({ ref_no: 'This reference number already exists' });
                setEditLoading(false);
                return;
            }

            // Update PO
            await axios.put(`${backendUrl}/api/purchase-order/${selectedPurchaseOrderId}/update-details`, editFormData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Purchase order updated successfully!',
                timer: 3000,
                showConfirmButton: false,
            });

            handleCloseEditModal();
            fetchPurchaseOrders(pagination.currentPage, true);
        } catch (error) {
            console.error('Error updating PO:', error);

            if (error.response?.status === 422) {
                // Handle validation errors from backend
                const backendErrors = error.response.data.errors || {};
                setEditErrors(backendErrors);

                if (backendErrors.ref_no) {
                    Swal.fire({
                        toast: true,
                        position: 'top-end',
                        icon: 'error',
                        title: backendErrors.ref_no[0],
                        timer: 3000,
                        showConfirmButton: false,
                    });
                }
            } else {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'Failed to update purchase order',
                    timer: 3000,
                    showConfirmButton: false,
                });
            }
        } finally {
            setEditLoading(false);
        }
    };

    // Delete purchase order
    const deletePurchaseOrder = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        });

        if (!result.isConfirmed) return;

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            await axios.delete(`${backendUrl}/api/purchase-order/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            // Refresh the list
            fetchPurchaseOrders(pagination.currentPage, true);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Purchase order deleted successfully!',
                timer: 3000,
                showConfirmButton: false,
            });
        } catch (error) {
            console.error('Error deleting purchase order:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to delete purchase order',
                timer: 3000,
                showConfirmButton: false,
            });
        }
    };

    // Export functionality
    const handleExport = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Build export parameters based on current filters
            const exportParams = new URLSearchParams();

            if (filters.dateRange.from) exportParams.append('from_date', filters.dateRange.from);
            if (filters.dateRange.to) exportParams.append('to_date', filters.dateRange.to);
            if (filters.vendorId) exportParams.append('vendor_id', filters.vendorId);
            if (filters.searchQuery) exportParams.append('search', filters.searchQuery);

            const response = await axios.get(`${backendUrl}/api/purchase-order/export?${exportParams.toString()}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                responseType: 'blob'
            });

            // Create download link
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            // Get filename from response headers or use default
            const contentDisposition = response.headers['content-disposition'];
            let filename = `purchase_orders_export_${new Date().toISOString().split('T')[0]}.xlsx`;

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="(.+)"/);
                if (filenameMatch) {
                    filename = filenameMatch[1];
                }
            }

            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Purchase orders exported successfully!',
                timer: 3000,
                showConfirmButton: false,
            });

        } catch (error) {
            console.error('Export error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to export purchase orders',
                timer: 3000,
                showConfirmButton: false,
            });
        }
    };

    // Import functionality
    const handleImport = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Validate file type
        const validTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'];
        if (!validTypes.includes(file.type)) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Please select a valid Excel or CSV file',
                timer: 3000,
                showConfirmButton: false,
            });
            return;
        }

        const result = await Swal.fire({
            title: 'Import Purchase Orders',
            text: 'Are you sure you want to import purchase orders from this file?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, import!',
            cancelButtonText: 'Cancel'
        });

        if (!result.isConfirmed) {
            event.target.value = '';
            return;
        }

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(`${backendUrl}/api/purchase-order/import`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                    'Content-Type': 'multipart/form-data',
                },
            });

            const result = response.data;

            let message = `Import completed successfully!<br>
                          Imported: ${result.imported_count || result.count || 0}`;

            if (result.errors && result.errors.length > 0) {
                message += `<br><br>Errors:<br>${result.errors.join('<br>')}`;
            }

            Swal.fire({
                title: 'Import Result',
                html: message,
                icon: 'success',
                confirmButtonText: 'OK'
            });

            // Refresh the list
            fetchPurchaseOrders(1, true);

        } catch (error) {
            console.error('Import error:', error);
            let errorMessage = 'Failed to import purchase orders';

            if (error.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error.message) {
                errorMessage = error.message;
            }

            Swal.fire({
                title: 'Import Failed',
                text: errorMessage,
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            event.target.value = '';
        }
    };

    // Initial data loading
    useEffect(() => {
        fetchVendors();
        fetchClients();
        fetchPurchaseOrders(1, false);
    }, []);

    // Calculate totals
    const totals = calculateTotals();

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Header */}
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Purchase Orders</h4>
                                <div className="page-title-right">
                                    <WithCreatePermission>
                                        <button
                                            className="btn btn-primary"
                                            onClick={() => handleShowModal()}
                                        >
                                            <FaPlus className="me-1" />
                                            Add Purchase Order
                                        </button>
                                    </WithCreatePermission>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Filter Panel */}
                    <div className="card filter-card mb-4">
                        <div className="card-body">
                            <h5 className="card-title mb-3">
                                <FaFilter className="me-2" />
                                Filter Purchase Orders
                            </h5>

                            <div className="row g-3">
                                {/* Date Filters */}
                                <div className="col-md-2">
                                    <label className="form-label">From Date</label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            views={["year", "month", "day"]}
                                            format="DD-MM-YYYY"
                                            value={
                                                filters.dateRange.from
                                                    ? dayjs(filters.dateRange.from)
                                                    : null
                                            }
                                            onChange={(newValue) => {
                                                updateFilter("dateRange", {
                                                    ...filters.dateRange,
                                                    from: newValue ? newValue.format("YYYY-MM-DD") : "",
                                                });
                                            }}
                                            slotProps={{
                                                textField: {
                                                    size: "small",
                                                    fullWidth: true,
                                                    className: "form-control",
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </div>

                                <div className="col-md-2">
                                    <label className="form-label">To Date</label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            views={["year", "month", "day"]}
                                            format="DD-MM-YYYY"
                                            value={
                                                filters.dateRange.to
                                                    ? dayjs(filters.dateRange.to)
                                                    : null
                                            }
                                            onChange={(newValue) => {
                                                updateFilter("dateRange", {
                                                    ...filters.dateRange,
                                                    to: newValue ? newValue.format("YYYY-MM-DD") : "",
                                                });
                                            }}
                                            slotProps={{
                                                textField: {
                                                    size: "small",
                                                    fullWidth: true,
                                                    className: "form-control",
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </div>


                                {/* Vendor Filter */}
                                <div className="col-md-2">
                                    <label className="form-label">Vendor</label>
                                    <select
                                        className="form-select"
                                        value={filters.vendorId}
                                        onChange={(e) => updateFilter('vendorId', e.target.value)}
                                    >
                                        <option value="">All Vendors</option>
                                        {[...vendors]
                                            .sort((a, b) => (a.name || a.business_name || "").localeCompare(b.name || b.business_name || ""))
                                            .map(vendor => (
                                                <option key={vendor.id} value={vendor.id}>
                                                    {vendor.name || vendor.business_name || `Vendor ${vendor.id}`}
                                                </option>
                                            ))}
                                    </select>
                                </div>

                                {/* Client Filter */}
                                <div className="col-md-2">
                                    <label className="form-label">Client</label>
                                    <select
                                        className="form-select"
                                        value={filters.clientId}
                                        onChange={(e) => updateFilter('clientId', e.target.value)}
                                    >
                                        <option value="">All Clients</option>
                                        {[...clients]
                                            .sort((a, b) => (a.name || a.business_name || "").localeCompare(b.name || b.business_name || ""))
                                            .map(client => (
                                                <option key={client.id} value={client.id}>
                                                    {client.name || client.business_name || `Client ${client.id}`}
                                                </option>
                                            ))}
                                    </select>
                                </div>

                                {/* Search */}
                                <div className="col-md-2">
                                    <label className="form-label">Search</label>
                                    <div className="input-group">
                                        <span className="input-group-text">
                                            <FaSearch />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search by reference no..."
                                            value={filters.searchQuery}
                                            onChange={(e) => updateFilter('searchQuery', e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Action Buttons */}
                            <div className="row g-3 mt-2">
                                <div className="col-md-12 d-flex align-items-end justify-content-between">
                                    <div>
                                        <button
                                            className="btn btn-primary me-2"
                                            onClick={applyFilters}
                                        >
                                            Apply Filters
                                        </button>
                                        <button
                                            className="btn btn-outline-secondary me-2"
                                            onClick={resetFilters}
                                        >
                                            Clear All
                                        </button>
                                    </div>
                                    <div className="d-flex align-items-center gap-2">
                                        <button
                                            type="button"
                                            className="btn btn-light border"
                                            onClick={handleExport}
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Export to Excel"
                                        >
                                            <FaFileExcel className="text-success" />
                                        </button>

                                        <input
                                            type="file"
                                            accept=".xlsx, .xls, .csv"
                                            id="importFile"
                                            onChange={handleImport}
                                            style={{ display: "none" }}
                                        />
                                        <label
                                            htmlFor="importFile"
                                            className="btn btn-light border mb-0"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Import from Excel"
                                        >
                                            <FaUpload className="text-primary" />
                                        </label>

                                        <button
                                            className="btn btn-outline-primary"
                                            onClick={() => fetchPurchaseOrders(1, true)}
                                        >
                                            <FaSync className="me-1" /> Refresh
                                        </button>

                                        <div className="text-muted ms-3">
                                            <small>
                                                Showing {purchaseOrders.length} of {pagination.total} records
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Purchase Orders Table */}
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h5 className="card-title mb-0">Purchase Orders</h5>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table align-middle table-nowrap table-check table-list">
                                            <thead className="table-sales-gradient">
                                                <tr>
                                                    <th>#</th>
                                                    <th>Client</th>
                                                    <th>Project</th>
                                                    <th>Vendor Name</th>
                                                    <th>Reference No</th>
                                                    <th>Date</th>
                                                    <th>Amount</th>
                                                    <th>Amount (AED)</th>
                                                    <th>VAT</th>
                                                    <th>VAT Amount</th>
                                                    <th>Total Amount (AED)</th>
                                                    <th>Allocated Amount (AED)</th>
                                                    <th>Balance (AED)</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {purchaseOrders.length > 0 ? (
                                                    purchaseOrders.map((order, index) => {
                                                        const isExpensePO = isPOFromExpense(order);
                                                        const showVAT = shouldShowVAT(order);
                                                        const vatPercentage = calculateVATPercentage(order);
                                                        const vatAmount = calculateVAT(order);
                                                        const displayAmount = getDisplayAmount(order);
                                                        const totalWithVAT = calculateTotalWithVAT(order);
                                                        const hasDocument = order.document;

                                                        // NEW CALCULATIONS
                                                        const vendorCurrency = getVendorCurrency(order);
                                                        const amountAED = getAEDAmount(order, displayAmount);
                                                        const vatAmountAED = getAEDAmount(order, vatAmount);
                                                        const totalAmountAED = getAEDAmount(order, totalWithVAT);
                                                        const usedAmount = getUsedAmount(order);
                                                        const usedAmountAED = getAEDAmount(order, usedAmount);
                                                        const balanceAmount = getBalanceAmount(order);
                                                        const balanceAmountAED = getAEDAmount(order, balanceAmount);

                                                        return (
                                                            <tr key={order.id}>
                                                                <td>{index + 1}</td>
                                                                <td>{order.client?.name || ''}</td>
                                                                <td>{order?.project?.name || ''}</td>
                                                                <td>
                                                                    {order.vendor?.name || ''}
                                                                </td>
                                                                {/* <td>
                                                                    {order.ref_no}
                                                                </td> */}
                                                                {/* In your table row render, replace the reference number cell */}
                                                                <td>
                                                                    {order.document ? (
                                                                        <button
                                                                            className="btn btn-link p-0 text-decoration-none"
                                                                            onClick={() => handleRefNoClick(order)}
                                                                            style={{ cursor: 'pointer' }}
                                                                        >
                                                                            <span className="text-dark">
                                                                                {order.ref_no}
                                                                                <FaPaperclip className="ms-1" size={12} />
                                                                            </span>
                                                                        </button>
                                                                    ) : (
                                                                        <span>{order.ref_no}</span>
                                                                    )}
                                                                </td>

                                                                <td>
                                                                    {new Date(order.date).toLocaleDateString()}
                                                                </td>
                                                                <td>
                                                                    {formatAmount(displayAmount)}
                                                                    <span className="text-muted ms-1 font-size-11">({vendorCurrency})</span>
                                                                </td>
                                                                <td>
                                                                    {formatAmount(amountAED)}
                                                                    <span className="text-muted ms-1 font-size-11"></span>
                                                                </td>
                                                                <td>
                                                                    {showVAT ? (
                                                                        `${vatPercentage}%`
                                                                    ) : null
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {showVAT ? (
                                                                        <div>
                                                                            <div>{formatAmount(vatAmount)} ({vendorCurrency})</div>
                                                                            <div className="font-size-11 text-muted">
                                                                                {formatAmount(vatAmountAED)} (AED)
                                                                            </div>
                                                                        </div>
                                                                    ) : null}
                                                                </td>
                                                                <td>
                                                                    <div>
                                                                        <div className="fw-bold">
                                                                            {formatAmount(totalAmountAED)}
                                                                        </div>
                                                                        <div className="font-size-11 text-muted">
                                                                            {showVAT ? (
                                                                                formatAmount(totalWithVAT)
                                                                            ) : (
                                                                                formatAmount(displayAmount)
                                                                            )} ({vendorCurrency})
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div>
                                                                        <div className="fw-bold">
                                                                            {formatAmount(usedAmountAED)}
                                                                        </div>
                                                                        <div className="font-size-11 text-muted">
                                                                            {formatAmount(usedAmount)} ({vendorCurrency})
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className={balanceAmountAED < 0 ? 'text-danger' : balanceAmountAED > 0 ? 'text-success' : ''}>
                                                                        <div className="fw-bold">
                                                                            {formatAmount(balanceAmountAED)}
                                                                        </div>
                                                                        <div className="font-size-11 text-muted">
                                                                            {formatAmount(balanceAmount)} ({vendorCurrency})
                                                                        </div>
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <div className="dropdown">
                                                                        <i
                                                                            className="mdi mdi-dots-horizontal font-size-18"
                                                                            data-bs-toggle="dropdown"
                                                                            aria-expanded="false"
                                                                            style={{ cursor: "pointer" }}
                                                                        ></i>
                                                                        <ul className="dropdown-menu">
                                                                            <li>
                                                                                <button
                                                                                    className="dropdown-item"
                                                                                    onClick={() => handleViewDetails(order)}
                                                                                >
                                                                                    <FaEye className="me-2" />
                                                                                    View Details
                                                                                </button>
                                                                            </li>
                                                                            <WithEditPermission>
                                                                                <li>
                                                                                    <button
                                                                                        className="dropdown-item"
                                                                                        onClick={() => handleShowModal(order.id)}
                                                                                    >
                                                                                        <FaEdit className="me-2" />
                                                                                        Edit Details
                                                                                    </button>
                                                                                </li>
                                                                                <li>
                                                                                    <button
                                                                                        className="dropdown-item"
                                                                                        onClick={() => handleShowUploadModal(order.id)}
                                                                                    >
                                                                                        <FaUpload className="me-2" />
                                                                                        {hasDocument ? 'Replace Document' : 'Upload Document'}
                                                                                    </button>
                                                                                </li>
                                                                            </WithEditPermission>
                                                                            <WithDeletePermission>
                                                                                <li>
                                                                                    <button
                                                                                        className="dropdown-item text-danger"
                                                                                        onClick={() => deletePurchaseOrder(order.id)}
                                                                                    >
                                                                                        <FaTrash className="me-2" />
                                                                                        Delete
                                                                                    </button>
                                                                                </li>
                                                                            </WithDeletePermission>
                                                                        </ul>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan="16" className="text-center py-4">
                                                            <div className="text-muted">
                                                                <FaFileInvoice size={48} className="mb-2" />
                                                                <p>No purchase orders found</p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                            {/* Footer with Totals */}
                                            {purchaseOrders.length > 0 && (
                                                <tfoot >
                                                    <tr>
                                                        <td colSpan="5" className="text-end fw-bold">
                                                            Totals:
                                                        </td>
                                                        <td></td> {/* Date column */}
                                                        <td></td> {/* Amount column (vendor currency) */}
                                                        <td >
                                                        </td>
                                                        <td></td> {/* VAT % column */}
                                                        <td className="fw-bold">
                                                        </td>
                                                        <td className="fw-bold bg-light">
                                                            {formatAmount(totals.totalAmountAED)} AED
                                                        </td>
                                                        <td className="fw-bold">
                                                            {formatAmount(totals.usedAmountAED)} AED
                                                        </td>
                                                        <td className={`fw-bold ${totals.balanceAmountAED < 0 ? 'text-danger' : totals.balanceAmountAED > 0 ? 'text-success' : ''}`}>
                                                            {formatAmount(totals.balanceAmountAED)} AED
                                                        </td>
                                                        <td colSpan="2"></td> {/* Status and Actions columns */}
                                                    </tr>
                                                    {/* Summary Row */}
                                                    {/* <tr className="bg-light">
                                                        <td colSpan="7" className="text-end fw-bold">
                                                            Summary:
                                                        </td>
                                                        <td colSpan="4">
                                                            <div className="d-flex justify-content-between">
                                                                <span>Total Amount:</span>
                                                                <span className="fw-bold">{formatAmount(totals.amountAED)} AED</span>
                                                            </div>
                                                            <div className="d-flex justify-content-between">
                                                                <span>Total VAT:</span>
                                                                <span className="fw-bold">{formatAmount(totals.vatAmountAED)} AED</span>
                                                            </div>
                                                        </td>
                                                        <td className="fw-bold">
                                                            <div className="d-flex justify-content-between">
                                                                <span>Total:</span>
                                                                <span>{formatAmount(totals.totalAmountAED)} AED</span>
                                                            </div>
                                                        </td>
                                                        <td className="fw-bold">
                                                            <div className="d-flex justify-content-between">
                                                                <span>Used:</span>
                                                                <span>{formatAmount(totals.usedAmountAED)} AED</span>
                                                            </div>
                                                        </td>
                                                        <td className={`fw-bold ${totals.balanceAmountAED < 0 ? 'text-danger' : totals.balanceAmountAED > 0 ? 'text-success' : ''}`}>
                                                            <div className="d-flex justify-content-between">
                                                                <span>Balance:</span>
                                                                <span>{formatAmount(totals.balanceAmountAED)} AED</span>
                                                            </div>
                                                        </td>
                                                        <td colSpan="2"></td>
                                                    </tr> */}
                                                </tfoot>
                                            )}
                                        </table>
                                    </div>

                                    {/* Pagination */}
                                    <div className="d-flex justify-content-end pagination-sm">
                                        <ReactPaginate
                                            previousLabel={'<'}
                                            nextLabel={'>'}
                                            breakLabel={'...'}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={handlePageChange}
                                            containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item previous'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item next'}
                                            nextLinkClassName={'page-link'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Purchase Order Modal */}
            <PurchaseOrderForm
                showModal={showModal}
                handleClose={handleCloseModal}
                poId={selectedPurchaseOrderId}
                purchaseorderData={selectedPurchaseOrderData}
                onSuccess={handleSuccess}
                vendors={vendors}
            />

            {/* ============ VIEW DETAILS OFFCANVAS ============ */}
            <Offcanvas
                show={showViewOffcanvas}
                onHide={handleCloseViewOffcanvas}
                placement="end"
                style={{ width: '780px', maxWidth: '95vw' }}
            >
                <Offcanvas.Header closeButton className="border-bottom">
                    <Offcanvas.Title>
                        <FaEye className="me-2 text-primary" />
                        PO Details — <span className="text-primary">{selectedViewPO?.ref_no || '...'}</span>
                    </Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body className="p-0">
                    {viewPOLoading && (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: 200 }}>
                            <Spinner animation="border" variant="primary" />
                            <span className="ms-3 text-muted">Loading details...</span>
                        </div>
                    )}

                    {selectedViewPO && (() => {
                        const po = selectedViewPO;
                        const currency = getVendorCurrency(po);
                        const displayAmt  = getDisplayAmount(po);
                        const vatAmt      = calculateVAT(po);
                        const totalAmt    = calculateTotalWithVAT(po);
                        const usedAmt     = getUsedAmount(po);
                        const balanceAmt  = getBalanceAmount(po);
                        const showVAT     = shouldShowVAT(po);
                        const items = po.productItemDetails || [];
                        const payments = po.payments || [];

                        /* ---- build allocation rows with running balance ---- */
                        let runningBalance = parseFloat(totalAmt);
                        const allocationRows = items.map((item, idx) => {
                            const allocated = parseFloat(item.price || item.amount || 0);
                            const tax       = parseFloat(item.tax || 0);
                            const allocTotal = allocated + tax;
                            const prevBalance = runningBalance;
                            runningBalance = runningBalance - allocTotal;
                            return {
                                idx,
                                expenseName:  item.item_name || item.itemName || `Expense ${idx + 1}`,
                                billNo:       item.bill_no || item.billNo || item.item_description || '—',
                                expenseRef:   item.productable?.ref_no || item.productable?.name || '',
                                allocated,
                                tax,
                                allocTotal,
                                balanceBefore: prevBalance,
                                balanceAfter:  runningBalance,
                            };
                        });

                        /* ---- group payment rows by voucher id ---- */
                        const paymentGroups = {};
                        payments.forEach(p => {
                            const key = p.voucher_id || p.transaction_id || p.id;
                            if (!paymentGroups[key]) {
                                // If we have a full breakdown from the transaction, use that as the source of truth for THIS VOUCHER
                                const hasFullBreakdown = p.full_breakdown && p.full_breakdown.length > 0;
                                const voucherBills = hasFullBreakdown ? p.full_breakdown : [{
                                    billNo: p.bill_no || '—',
                                    amount: parseFloat(p.amount || 0),
                                    balance: parseFloat(p.balance_after || 0),
                                    expenseName: p.expense_name || '—',
                                }];

                                paymentGroups[key] = {
                                    voucherId:      p.voucher_id || p.transaction_id || p.id,
                                    date:           p.transaction_date || p.date || p.created_at,
                                    currency:       currency, 
                                    bankCurrency:   p.transaction_currency,
                                    bankAmount:     p.transaction_amount,
                                    description:    p.transaction_description,
                                    totalAmount:    voucherBills.reduce((sum, b) => sum + (b.amount || 0), 0),
                                    bills:          voucherBills,
                                };
                            }
                        });
                        const paymentRows = Object.values(paymentGroups);

                        const fmtDate = (d) => {
                            if (!d) return '—';
                            try { return new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }); }
                            catch { return d; }
                        };

                        const statusConfig = {
                            'vendor_PO_generated':   { label: 'Generated',  cls: 'primary' },
                            'approved':              { label: 'Approved',   cls: 'success' },
                            'pending':               { label: 'Pending',    cls: 'warning' },
                            'rejected':              { label: 'Rejected',   cls: 'danger'  },
                            'completed':             { label: 'Completed',  cls: 'info'    },
                            'vendor_payment_released': { label: 'Paid',     cls: 'success' },
                        };
                        const statusCfg = statusConfig[po.po_status || po.status] || { label: po.po_status || po.status || '—', cls: 'secondary' };

                        return (
                            <div className="bg-light pb-4" style={{ minHeight: '100vh' }}>
                                {/* ===== SECTION 1: PO Overview ===== */}
                                <div className="px-4 py-4 bg-white border-bottom shadow-sm">
                                    <div className="d-flex justify-content-between align-items-start mb-4">
                                        <h6 className="fw-bold text-dark d-flex align-items-center m-0 fs-5">
                                            <span className="bg-info bg-opacity-10 text-info p-2 rounded me-3 shadow-sm">
                                                <FaFileInvoice size={18} />
                                            </span>
                                            Purchase Order Details
                                        </h6>
                                        <div className="d-flex align-items-center bg-light px-3 py-2 rounded border">
                                            <span className="text-muted small me-2 fw-medium">Status:</span>
                                            <span className={`badge bg-${statusCfg.cls} rounded-pill border`}>
                                                {statusCfg.label}
                                            </span>
                                        </div>
                                    </div>
                                    
                                    <div className="row g-4 mb-4">
                                        <div className="col-md-6">
                                            <div className="p-3 bg-light rounded border h-100 shadow-sm d-flex flex-column justify-content-between">
                                                <div className="d-flex align-items-start gap-3 mb-3">
                                                    <div className="bg-white p-2 rounded border shadow-sm text-primary">
                                                        <i className="mdi mdi-barcode-scan fs-4"></i>
                                                    </div>
                                                    <div>
                                                        <span className="text-muted small fw-semibold text-uppercase">Reference No</span>
                                                        <div className="fw-bold text-dark fs-5 mt-1">{po.ref_no || '—'}</div>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-between align-items-center pt-3 border-top mt-auto">
                                                    <span className="text-muted small fw-semibold">Date</span>
                                                    <div className="fw-medium text-dark bg-white px-2 py-1 rounded border shadow-sm">
                                                        <i className="mdi mdi-calendar-today text-primary me-1"></i> {fmtDate(po.date)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="col-md-6">
                                            <div className="p-3 bg-light rounded border h-100 shadow-sm">
                                                <div className="row g-3">
                                                    <div className="col-6">
                                                        <span className="text-muted small d-block mb-1 fw-semibold text-uppercase">Client</span>
                                                        <div className="fw-bold text-dark text-truncate" title={po.client?.name || po.client?.business_name || '—'}>
                                                            {po.client?.name || po.client?.business_name || '—'}
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <span className="text-muted small d-block mb-1 fw-semibold text-uppercase">Vendor</span>
                                                        <div className="fw-bold text-dark text-truncate" title={po.vendor?.name || po.vendor?.business_name || '—'}>
                                                            {po.vendor?.name || po.vendor?.business_name || '—'}
                                                        </div>
                                                    </div>
                                                    <div className="col-6 pt-2 border-top">
                                                        <span className="text-muted small d-block mb-1 fw-semibold text-uppercase">Project</span>
                                                        <div className="fw-bold text-dark text-truncate" title={po.project?.name || '—'}>
                                                            {po.project?.name || '—'}
                                                        </div>
                                                    </div>
                                                    <div className="col-6 pt-2 border-top">
                                                        <span className="text-muted small d-block mb-1 fw-semibold text-uppercase">Currency</span>
                                                        <div className="fw-bold text-dark bg-white d-inline-block px-2 py-1 rounded border shadow-sm">{currency}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Amount summary cards */}
                                    <div className="row g-3">
                                        <div className="col-6 col-lg">
                                            <div className="border rounded px-3 py-3 bg-white shadow-sm position-relative overflow-hidden h-100">
                                                <div className="text-muted small fw-semibold text-uppercase mb-2">Base Amount</div>
                                                <div className="fw-bold fs-5 text-dark">{formatAmount(displayAmt)} <span className="small text-muted">{currency}</span></div>
                                            </div>
                                        </div>
                                        {showVAT && (
                                            <div className="col-6 col-lg">
                                                <div className="border rounded px-3 py-3 bg-white shadow-sm position-relative overflow-hidden h-100">
                                                    <div className="text-muted small fw-semibold text-uppercase mb-2">VAT Amount</div>
                                                    <div className="fw-bold fs-5 text-dark">{formatAmount(vatAmt)} <span className="small text-muted">{currency}</span></div>
                                                </div>
                                            </div>
                                        )}
                                        <div className="col-6 col-lg">
                                            <div className="border rounded px-3 py-3 bg-white shadow-sm position-relative overflow-hidden h-100 border-primary border-opacity-50">
                                                <div className="text-muted small fw-semibold text-uppercase mb-2">Total PO</div>
                                                <div className="fw-bold fs-5 text-primary">{formatAmount(totalAmt)} <span className="small opacity-75">{currency}</span></div>
                                            </div>
                                        </div>
                                        <div className="col-6 col-lg">
                                            <div className="border rounded px-3 py-3 bg-white shadow-sm position-relative overflow-hidden h-100">
                                                <div className="text-muted small fw-semibold text-uppercase mb-2">Allocated</div>
                                                <div className="fw-bold fs-5 text-warning">{formatAmount(usedAmt)} <span className="small opacity-75">{currency}</span></div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-auto" style={{minWidth: '220px'}}>
                                            <div className={`border rounded px-4 py-3 shadow-sm h-100 d-flex flex-column justify-content-center ${balanceAmt < 0 ? 'bg-danger bg-opacity-10 border-danger' : balanceAmt > 0 ? 'bg-success bg-opacity-10 border-success' : 'bg-light'}`}>
                                                <div className="text-muted small fw-bold text-uppercase mb-1">Balance</div>
                                                <div className={`fw-bold fs-3 ${balanceAmt < 0 ? 'text-danger' : balanceAmt > 0 ? 'text-success' : 'text-dark'}`}>
                                                    {formatAmount(balanceAmt)} <span className="fs-6 opacity-75">{currency}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* ===== SECTION 2: Allocation Details ===== */}
                                <div className="px-4 py-4 border-bottom bg-white mt-3 shadow-sm">
                                    <h6 className="fw-bold text-dark mb-4 d-flex align-items-center fs-5">
                                        <span className="bg-warning bg-opacity-10 text-warning p-2 rounded me-3 shadow-sm">
                                            <i className="mdi mdi-cash-multiple fs-5" />
                                        </span>
                                        Amount Allocation Details
                                    </h6>
                                    
                                    {allocationRows.length === 0 ? (
                                        <div className="text-center text-muted p-5 bg-light rounded border border-dashed shadow-sm">
                                            <div className="bg-white rounded-circle d-inline-flex p-3 shadow-sm mb-3">
                                                <i className="mdi mdi-information-outline fs-2 text-secondary" />
                                            </div>
                                            <h6 className="fw-medium text-dark">No allocations yet</h6>
                                            <p className="mb-0 small">This purchase order hasn't been allocated to any expenses.</p>
                                        </div>
                                    ) : (
                                        <div className="d-flex flex-column gap-4">
                                            {allocationRows.map((row) => (
                                                <div key={row.idx} className="border rounded bg-white shadow-sm overflow-hidden">
                                                    <div className="d-flex justify-content-between align-items-center p-3 border-bottom bg-light">
                                                        <div className="d-flex align-items-center gap-3">
                                                            <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center shadow-sm" style={{width: 36, height: 36, fontSize: 14, fontWeight: 600}}>
                                                                {row.idx + 1}
                                                            </div>
                                                            <div>
                                                                <div className="fw-bold text-dark fs-6">{row.expenseName}</div>
                                                                {row.expenseRef && <div className="text-muted small d-flex align-items-center mt-1"><i className="mdi mdi-tag-outline me-1"></i> {row.expenseRef}</div>}
                                                            </div>
                                                        </div>
                                                        <div className="bg-white border rounded px-3 py-2 shadow-sm d-flex align-items-center">
                                                            <span className="text-muted small fw-medium me-2">Bill No:</span> 
                                                            <span className="fw-bold text-dark">{row.billNo}</span>
                                                        </div>
                                                    </div>
                                                    <div className="p-3">
                                                        <div className="row g-3">
                                                            <div className="col-6 col-md-3 border-end">
                                                                <div className="text-muted small mb-1 fw-medium">Allocated Amount</div>
                                                                <div className="fw-bold text-dark fs-5">{formatAmount(row.allocated)} <span className="small text-muted fw-normal">{currency}</span></div>
                                                            </div>
                                                            {showVAT && (
                                                                <div className="col-6 col-md-3 border-end">
                                                                    <div className="text-muted small mb-1 fw-medium">VAT Amount</div>
                                                                    <div className="fw-bold text-dark fs-5">{formatAmount(row.tax)} <span className="small text-muted fw-normal">{currency}</span></div>
                                                                </div>
                                                            )}
                                                            <div className="col-6 col-md-3 border-end">
                                                                <div className="text-muted small mb-1 fw-medium">Total Allocation</div>
                                                                <div className="fw-bold text-primary fs-5">{formatAmount(row.allocTotal)} <span className="small opacity-75 fw-normal">{currency}</span></div>
                                                            </div>
                                                            <div className="col-6 col-md-3">
                                                                <div className="text-muted small mb-1 fw-medium">Running Balance</div>
                                                                <div className={`fw-bold fs-5 ${row.balanceAfter < 0 ? 'text-danger' : 'text-success'}`}>
                                                                    {formatAmount(row.balanceAfter)} <span className="small opacity-75 fw-normal">{currency}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                            
                                            <div className="d-flex justify-content-end align-items-center p-3 bg-light rounded border shadow-sm mx-2">
                                                 <span className="text-muted me-3 fw-medium text-uppercase small">Total Allocated:</span>
                                                 <span className="fs-4 fw-bold text-dark">{formatAmount(usedAmt)} <span className="fs-6 text-muted">{currency}</span></span>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* ===== SECTION 3: Payment Details ===== */}
                                <div className="px-4 py-4 bg-white mt-3 shadow-sm border-bottom">
                                    <h6 className="fw-bold text-dark mb-4 d-flex align-items-center fs-5">
                                        <span className="bg-success bg-opacity-10 text-success p-2 rounded me-3 shadow-sm">
                                            <i className="mdi mdi-bank-transfer fs-5" />
                                        </span>
                                        Payment Transactions
                                    </h6>
                                    
                                    {paymentRows.length === 0 ? (
                                        <div className="text-center text-muted p-5 bg-light rounded border border-dashed shadow-sm">
                                            <div className="bg-white rounded-circle d-inline-flex p-3 shadow-sm mb-3">
                                                <i className="mdi mdi-cash-remove fs-2 text-secondary" />
                                            </div>
                                            <h6 className="fw-medium text-dark">No payments recorded</h6>
                                            <p className="mb-0 small">There are no payment transactions logged for this purchase order yet.</p>
                                        </div>
                                    ) : (
                                        <div className="row g-4">
                                            {paymentRows.map((grp, gi) => (
                                                <div key={grp.voucherId} className="col-12">
                                                    <div className="card shadow-sm border h-100 overflow-hidden">
                                                        <div className="card-header bg-light border-bottom p-3 d-flex flex-wrap justify-content-between align-items-center gap-3">
                                                            <div className="d-flex align-items-center gap-3">
                                                                <div className="bg-success text-white p-2 rounded shadow-sm">
                                                                    <i className="mdi mdi-receipt fs-4"></i>
                                                                </div>
                                                                <div>
                                                                    <div className="text-muted small mb-1 fw-semibold text-uppercase">Voucher ID</div>
                                                                    <div className="fw-bold text-dark fs-5">{grp.voucherId}</div>
                                                                    {grp.description && (
                                                                        <div className="text-muted small mt-1 font-italic" style={{ maxWidth: '300px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={grp.description}>
                                                                            {grp.description}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            
                                                            <div className="d-flex gap-4 align-items-center bg-white px-4 py-2 rounded border shadow-sm">
                                                                <div>
                                                                    <div className="text-muted small mb-1 fw-semibold">Date</div>
                                                                    <div className="fw-medium text-dark d-flex align-items-center">
                                                                        <i className="mdi mdi-calendar-blank-outline text-primary me-2"></i>{fmtDate(grp.date)}
                                                                    </div>
                                                                </div>
                                                                <div className="text-end ps-4 border-start border-2">
                                                                    <div className="text-muted small mb-1 fw-semibold">Total Paid</div>
                                                                    <div className="fw-bold text-success fs-5">
                                                                        {formatAmount(grp.totalAmount)} <span className="small text-muted">{grp.currency}</span>
                                                                    </div>
                                                                    {grp.bankCurrency !== grp.currency && (
                                                                        <div className="text-muted small mt-n1">
                                                                            {formatAmount(grp.bankAmount)} {grp.bankCurrency}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                        <div className="card-body p-0">
                                                            {grp.bills.length > 0 && (
                                                                <div className="list-group list-group-flush">
                                                                    {grp.bills.map((bill, bi) => (
                                                                        <div key={bi} className="list-group-item p-3 border-bottom-0 border-top bg-white d-flex justify-content-between align-items-center">
                                                                            <div className="d-flex align-items-center gap-3">
                                                                                <div className="bg-light text-muted fw-bold rounded-circle d-flex align-items-center justify-content-center" style={{width: 28, height: 28, fontSize: 12}}>
                                                                                    {bi + 1}
                                                                                </div>
                                                                                <div>
                                                                                    <div className="fw-bold text-dark">{bill.expenseName}</div>
                                                                                    <div className="text-muted small mt-1 d-flex align-items-center">
                                                                                        <i className="mdi mdi-file-document-outline me-1 text-primary"></i> Bill No: <span className="text-dark fw-medium ms-1">{bill.billNo}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="text-end">
                                                                                <div className="d-flex flex-column align-items-end gap-1">
                                                                                    <div className="bg-light border rounded px-3 py-1 shadow-sm" style={{minWidth: '140px'}}>
                                                                                        <span className="text-muted small me-2">Paid:</span>
                                                                                        <span className="fw-bold text-success">{formatAmount(bill.amount)}</span>
                                                                                        <span className="text-muted small ms-1">{grp.currency}</span>
                                                                                    </div>
                                                                                    {bill.balance !== undefined && (
                                                                                        <div className="pe-2">
                                                                                            <span className="text-muted fw-medium" style={{fontSize: '11px'}}>
                                                                                                Balance: {formatAmount(bill.balance)} {grp.currency}
                                                                                            </span>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })()}
                </Offcanvas.Body>
            </Offcanvas>
            {/* ============ END VIEW DETAILS OFFCANVAS ============ */}
            {/* Add this before the final closing </div> */}
            {/* Document Preview Offcanvas */}
            <Offcanvas
                show={showDocOffcanvas}
                onHide={() => {
                    setShowDocOffcanvas(false);
                    setSelectedDocument(null);
                    setSelectedPOForDoc(null);
                }}
                placement="end"
                style={{ width: '700px' }}
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        <FaPaperclip className="me-2" />
                        Document - {selectedPOForDoc?.ref_no || 'Purchase Order'}
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {selectedDocument && (
                        <div className="document-preview-container">
                            <div className="mb-3">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h6>Document Preview</h6>
                                    <Button
                                        variant="primary"
                                        size="sm"
                                        onClick={() => {
                                            const backendUrl = process.env.REACT_APP_BACKEND_URL;
                                            const fileUrl = `${backendUrl}/storage/${selectedDocument}`;
                                            window.open(fileUrl, '_blank');
                                        }}
                                    >
                                        <FaDownload className="me-1" />
                                        Download
                                    </Button>
                                </div>
                            </div>

                            <div className="document-content border rounded p-3" style={{ minHeight: '500px' }}>
                                <DocumentPreview documentPath={selectedDocument} />
                            </div>

                            {selectedPOForDoc && (
                                <div className="mt-4 pt-3 border-top">
                                    <h6>Purchase Order Details</h6>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-2">
                                                <small className="text-muted">Vendor:</small>
                                                <div className="fw-medium">
                                                    {selectedPOForDoc.vendor?.name || selectedPOForDoc.vendor?.business_name || 'N/A'}
                                                </div>
                                            </div>
                                            <div className="mb-2">
                                                <small className="text-muted">Date:</small>
                                                <div className="fw-medium">
                                                    {new Date(selectedPOForDoc.date).toLocaleDateString()}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-2">
                                                <small className="text-muted">Total Amount:</small>
                                                <div className="fw-medium">
                                                    {formatAmount(getDisplayAmount(selectedPOForDoc))} ({getVendorCurrency(selectedPOForDoc)})
                                                </div>
                                            </div>
                                            <div className="mb-2">
                                                <small className="text-muted">Status:</small>
                                                <div>
                                                    <StatusBadge status={selectedPOForDoc.status} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </Offcanvas.Body>
            </Offcanvas>

            {/* Upload Document Modal */}
            <Offcanvas show={showUploadModal} onHide={handleCloseUploadModal} placement="end" style={{ width: '600px' }}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        <FaUpload className="me-2" />
                        Upload Document
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="mb-3">
                        <Form.Label>Select Document</Form.Label>
                        <Form.Control
                            type="file"
                            accept=".jpg,.jpeg,.png,.gif,.pdf"
                            onChange={handleFileChange}
                        />
                        <Form.Text className="text-muted">
                            Supported formats: JPG, PNG, GIF, PDF (Max 5MB)
                        </Form.Text>
                    </div>

                    {uploadFile && (
                        <div className="mb-3">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <Form.Label>Selected File</Form.Label>
                                <Button
                                    variant="link"
                                    size="sm"
                                    onClick={() => setUploadFile(null)}
                                    className="text-danger"
                                >
                                    <FaTimes /> Remove
                                </Button>
                            </div>
                            <div className="border rounded p-3">
                                <div className="d-flex align-items-center">
                                    {uploadFile.type.startsWith('image/') ? (
                                        <FaFileImage className="me-2 text-primary" size={24} />
                                    ) : (
                                        <FaFilePdf className="me-2 text-danger" size={24} />
                                    )}
                                    <div>
                                        <strong>{uploadFile.name}</strong>
                                        <div className="text-muted small">
                                            {(uploadFile.size / 1024 / 1024).toFixed(2)} MB
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {selectedPurchaseOrderId && purchaseOrders.find(po => po.id === selectedPurchaseOrderId)?.document && (
                        <div className="mb-3">
                            <Form.Label>Current Document</Form.Label>
                            <DocumentPreview
                                documentPath={purchaseOrders.find(po => po.id === selectedPurchaseOrderId)?.document}
                            />
                        </div>
                    )}
                </Offcanvas.Body>
                <div className="p-3 border-top">
                    <div className="d-flex justify-content-end gap-2">
                        <Button variant="secondary" onClick={handleCloseUploadModal}>
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleUploadSubmit}
                            disabled={!uploadFile || uploadLoading}
                        >
                            {uploadLoading ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    Uploading...
                                </>
                            ) : (
                                'Upload Document'
                            )}
                        </Button>
                    </div>
                </div>
            </Offcanvas>

        </div>
    );
};

export default PODetails;
